const translations = {
  th: {
    // ── Navbar ──
    booking:        "จองห้องพัก",
    status:         "สถานะ",
    profile:        "โปรไฟล์",
    logout:         "ออกจากระบบ",
    login:          "เข้าสู่ระบบ",
    dashboard:      "แดชบอร์ด",
    manageRooms:    "จัดการห้อง",
    manageMembers:  "จัดการสมาชิก",
    editReceipt:    "แก้ไขใบเสร็จ",
    editItems:      "แก้ไขรายการสินค้า",
    editPaymentSettings: "ตั้งค่าบัญชีรับเงิน",
    report:         "สร้างรายงาน",
    roomBooking:    "จองห้องพัก",
    roomManage:     "จัดการห้อง",
    roomDetail:     "รายละเอียดห้อง",
    cancelReq:      "คำขอยกเลิก",
    checkIn:        "เช็คอิน",
    checkOut:       "เช็คเอ้า",
    verifySlip:     "ตรวจสลิป",

    // ── Rooms page ──
    checkInLabel:   "เช็คอิน",
    nightsLabel:    "จำนวนคืน",
    nightsUnit:     "คืน",
    checkoutLabel:  "เช็คเอาท์",
    guestsLabel:    "ผู้เข้าพัก",
    adults:         "ผู้ใหญ่",
    adultsAge:      "อายุ 18 ปีขึ้นไป",
    rooms:          "ห้อง",
    roomsCount:     "จำนวนห้องพัก",
    confirm:        "ตกลง",
    filterLabel:    "ตัวกรอง",
    filterClear:    "ล้างตัวกรอง",
    roomType:       "ประเภทห้อง",
    roomRate:       "ราคาห้อง",
    sortByPrice:    "เรียงตามราคา",
    sortDefault:    "ค่าเริ่มต้น",
    sortAsc:        "น้อย → มาก ↑",
    sortDesc:       "มาก → น้อย ↓",
    allTypes:       "ทั้งหมด",
    resultInfo:     (n, a, ni) => `พบ ${n} ห้อง · ${a} คน · ${ni} คืน`,
    noRooms:        "ไม่พบห้องที่ตรงกับเงื่อนไข",
    breakfast:      "รวมอาหารเช้า",
    capacity:       (a, c) => `รองรับ ${a} ผู้ใหญ่${c > 0 ? ` + ${c} เด็ก` : ""}`,
    perNight:       "THB / คืน",
    totalNights:    (n, p) => `รวม ${n} คืน: ${p} THB`,
    viewDetail:     "ดูรายละเอียด →",
    priceUp:        "ราคา ↑",
    priceDown:      "ราคา ↓",

    // ── ตะกร้าห้องพัก ──
    addToCart:      "เพิ่มลงตะกร้า",
    soldOut:        "เต็ม",
    roomsLeft:      (n) => `เหลือ ${n} ห้อง`,
    cartTitle:      "ตะกร้าห้องพัก",
    cartCount:      (r, ty) => `${r} ห้อง · ${ty} ประเภท`,
    cartEmpty:      "ยังไม่ได้เลือกห้อง",
    cartClear:      "ล้างตะกร้า",
    cartView:       "ดูรายการ",
    cartOpen:       "เปิดตะกร้า",
    cartClose:      "ปิด",
    cartHide:       "ซ่อนรายการ",
    cartCheckout:   (n) => `ดำเนินการจอง ${n} ห้อง →`,
    cartTotal:      "ยอดรวม",
    cartRemove:     "ลบ",
    cartAdded:      (name) => `เพิ่ม ${name} ลงตะกร้าแล้ว`,
    cartTrimmed:    "จำนวนห้องบางรายการถูกปรับตามห้องว่างของวันที่ใหม่",
    cartMaxReached: (n) => `เลือกได้สูงสุด ${n} ห้องต่อการจอง`,
    cartSoldOutMsg: "ประเภทห้องนี้เต็มในช่วงวันที่เลือก",
    availError:     "ตรวจสอบห้องว่างไม่สำเร็จ กรุณาลองใหม่",
    rdAddToCart:    "เพิ่มลงตะกร้า",
    grandTotal:     "ยอดรวมทั้งหมด",
    payItemLine:    (name, qty) => `${name} × ${qty} ห้อง`,
    payRoomsTitle:  "รายการห้องพัก",
    payMultiHeading:(rooms, types) => `จองทั้งหมด ${rooms} ห้อง · ${types} ประเภท`,
    payQtyChip:     (n) => `× ${n} ห้อง`,

    // ── Status page ──
    allBookings:    "รายการจองทั้งหมด",
    roomNoLabel:    "ห้องเลขที่",
    myBookings:     "สถานะการจอง",
    items:          "รายการ",
    searchStaff:    "ค้นหาลูกค้า, ห้อง, อีเมล...",
    searchUser:     "ค้นหาประเภทห้อง, เลขห้อง...",
    loading:        "กำลังโหลด...",
    noBookings:     "ยังไม่มีการจองห้องพัก",
    noCategoryItems:"ไม่มีรายการในหมวดนี้",
    noSearchResult: (q) => `ไม่พบรายการที่ตรงกับ "${q}"`,
    bookingDate:    "วันที่จอง",
    checkInDate:    "เช็คอิน",
    checkOutDate:   "เช็คเอาท์",
    nightsCount:    "จำนวนคืน",
    total:          "ยอดรวม",
    details:        "รายละเอียด",
    allStatus:      "ทั้งหมด",
    dateFilterBy:   "กรองตามวันที่จอง :",
    dateAll:        "ทั้งหมด",
    dateDay:        "รายวัน",
    dateMonth:      "รายเดือน",
    dateRange:      "ช่วงวันที่",
    dateTo:         "ถึง",
    noPeriodItems:  "ไม่มีรายการจองในช่วงเวลาที่เลือก",

    // ── Booking detail ──
    bookingDetail:  "รายละเอียดการจอง",
    back:           "← ย้อนกลับ",
    cancelBooking:  "ยกเลิกการจอง",
    statusLabel:    "สถานะ",

    // ── Status labels ──
    Pending:        "รอการยืนยัน",
    Approved:       "อนุมัติแล้ว",
    Confirmed:      "จองสำเร็จ",
    CheckedIn:      "เช็คอินแล้ว",
    CheckedOut:     "เช็คเอาท์แล้ว",
    Cancelled:      "ยกเลิกแล้ว",
    PendingCancel:  "รอยืนยันการยกเลิก",

    // ── Login ──
    loginTitle:     "เข้าสู่ระบบ",
    emailLabel:     "อีเมล",
    passwordLabel:  "รหัสผ่าน",
    forgotPassword: "ลืมรหัสผ่าน?",
    noAccount:      "ยังไม่มีบัญชี?",
    registerLink:   "สมัครสมาชิก",
    loginWith:      "หรือเข้าสู่ระบบด้วย",

    // ── Register ──
    registerTitle:  "สมัครสมาชิก",
    firstnameLabel: "ชื่อ",
    lastnameLabel:  "นามสกุล",
    phoneLabel:     "เบอร์โทรศัพท์",
    confirmPass:    "ยืนยันรหัสผ่าน",
    haveAccount:    "มีบัญชีอยู่แล้ว?",
    registerBtn:    "สมัครสมาชิก",
    agreeTerms:     "ฉันยอมรับ",
    termsLink:      "เงื่อนไขการใช้งาน",
    and:            "และ",
    privacyLink:    "นโยบายความเป็นส่วนตัว",

    // ── Profile ──
    profileTitle:   "ข้อมูลส่วนตัว",
    editProfile:    "แก้ไขข้อมูล",
    saveProfile:    "บันทึก",
    cancelEdit:     "ยกเลิก",
    bookingHistory: "ประวัติการจอง",

    // ── Booking detail ──
    roomDefault:    "ห้องพัก",
    breakfastIncl:  "รวมอาหารเช้า",
    noPets:         "ไม่อนุญาตสัตว์เลี้ยง",
    persons:        "คน",
    beds:           "เตียง",
    bookingSection: "รายละเอียดการจอง",
    bookedAt:       "วันที่จอง",
    checkInDate2:   "วันเช็คอิน",
    checkOutDate2:  "วันเช็คเอาท์",
    nightsCount2:   "จำนวนคืน",
    totalAmount:    "ยอดรวม",
    paidAmountLbl:  "ชำระแล้ว",
    remainingLbl:   "ค้างชำระ",
    statusColon:    "สถานะ",
    cancelBtn:      "ยกเลิกการจอง",
    pendingPayment: "รอการชำระเงิน",
    pendingPaySub:  "ลูกค้ายังไม่ได้ชำระ — รอสลิปโอนเงิน หรือจ่ายเงินสดที่เคาน์เตอร์",
    checkSlip:      "ตรวจสอบสลิป →",
    paidReadyIn:    "ชำระเงินสำเร็จ — พร้อมเช็คอิน",
    unpaidReadyIn:  "ยังไม่ชำระเงิน — ห้องถูกจองไว้แล้ว",
    partialReadyIn: "ชำระบางส่วน — ยังมียอดค้าง",
    collectAtDesk:  "เก็บเงินที่เคาน์เตอร์ตอนเช็คอิน",
    confirmedReadyIn:"จองสำเร็จ — พร้อมเช็คอิน",
    stayingReadyOut:"ลูกค้าเข้าพักอยู่ — พร้อมเช็คเอาท์",
    checkoutDone:   "เช็คเอาท์เรียบร้อย",
    stayComplete:   "การเข้าพักเสร็จสมบูรณ์",
    pendingCancelTitle: "รอพิจารณาคำขอยกเลิก",
    pendingCancelSub:   "ลูกค้าขอยกเลิก — รอ admin ตรวจสอบ",
    reviewCancel:   "พิจารณา →",
    checkInBtn:     "เช็คอิน",
    checkOutBtn:    "เช็คเอาท์",

    // ── Login ──
    signIn:         "เข้าสู่ระบบ",
    continueGoogle: "เข้าสู่ระบบด้วย Google",
    orEmail:        "หรือเข้าสู่ระบบด้วยอีเมล",
    signingIn:      "กำลังเข้าสู่ระบบ...",
    logIn:          "เข้าสู่ระบบ",
    forgotPass:     "ลืมรหัสผ่าน?",
    createAccount:  "สร้างบัญชี",

    // ── Register ──
    createAccTitle: "สมัครสมาชิก",
    sendingOtp:     "กำลังส่ง OTP...",
    createAccBtn:   "สมัครสมาชิก",
    alreadyHaveAcc: "มีบัญชีอยู่แล้ว? เข้าสู่ระบบ",
    agreeToThe:     "ยอมรับ",
    termsOfUse:     "เงื่อนไขการใช้งาน",
    andWord:        "และ",
    privacyPol:     "นโยบายความเป็นส่วนตัว",
    passMatch:      "✓ รหัสผ่านตรงกัน",
    passNoMatch:    "✗ รหัสผ่านไม่ตรงกัน",
    pwdMin:         "อย่างน้อย 8 ตัวอักษร",
    pwdUpper:       "ตัวพิมพ์ใหญ่ 1 ตัว",
    pwdLower:       "ตัวพิมพ์เล็ก 1 ตัว",
    pwdNumber:      "ตัวเลข 1 ตัว",
    pwdSpecial:     "อักขระพิเศษ 1 ตัว",

    // ── ForgotPassword / ResetPassword / VerifyOTP ──
    forgotPwdTitle: "ลืมรหัสผ่าน",
    sendOtp:        "ส่ง OTP",
    resetPwdTitle:  "รีเซ็ตรหัสผ่าน",
    newPassword:    "รหัสผ่านใหม่",
    saving:         "กำลังบันทึก...",
    savePassword:   "บันทึกรหัสผ่าน",
    verifyOtpTitle: "ยืนยัน OTP",
    enterOtp:       "กรอก OTP",
    verifying:      "กำลังตรวจสอบ...",
    verifyBtn:      "ยืนยัน",

    // ── RoomDetail ──
    rdLoadFail:     "โหลดข้อมูลห้องพักไม่สำเร็จ",
    rdServerError:  "เซิร์ฟเวอร์อาจไม่ตอบสนอง หรือห้องนี้ถูกลบไปแล้ว",
    retry:          "ลองใหม่",
    backToRooms:    "กลับไปเลือกห้อง",
    highlight:      "ไฮไลท์",
    breakfastIncluded: "รวมอาหารเช้า",
    petsAllowed:    "สัตว์เลี้ยงได้",
    noPetsAllowed:  "ไม่อนุญาตสัตว์เลี้ยง",
    // เตียงในห้อง — ใช้ผ่าน utils/beds.js (RoomDetail, BookingDetailPage, preview หน้า AdminRooms)
    bedSpec:        (size, n) => `${size} ฟุต × ${n} เตียง`,
    facilities:     "สิ่งอำนวยความสะดวก",
    facWaterHeater: "เครื่องทำน้ำอุ่น",
    facTelevision:  "โทรทัศน์",
    facAirCon:      "เครื่องปรับอากาศ",
    facWifi:        "Wi-Fi",
    facWasher:      "เครื่องซักผ้า",
    facFridge:      "ตู้เย็น",
    reviewTitle:    "รีวิว",
    reviewScore:    "ดีมาก",
    rdCheckIn:      "เช็คอิน",
    rdCheckOut:     "เช็คเอาท์",
    rdPerson:       "จำนวนคน",
    rdBookBtn:      "จอง →",

    // ── Profile page ──
    profileUser:    "โปรไฟล์ผู้ใช้",
    changePhoto:    "เปลี่ยนรูป",
    save:           "บันทึก",
    editBtn:        "แก้ไข",
    fullName:       "ชื่อ-นามสกุล",
    addressLabel:   "ที่อยู่",
    birthdayLabel:  "วันเกิด",
    genderLabel:    "เพศ",
    countryLabel:   "ประเทศ",
    phoneNumLabel:  "เบอร์โทรศัพท์",
    optionalTag:    "ไม่บังคับ",
    accountSecurity:"ความปลอดภัยของบัญชี",
    mobileLabel:    "เบอร์โทรศัพท์มือถือ",
    changePwdEmail: "เปลี่ยนรหัสผ่านผ่านอีเมล",
    changeBtn:      "เปลี่ยน",
    lastLogin:      "การเข้าสู่ระบบล่าสุด",
    bookingHistoryTitle: "ประวัติการจอง",
    noHistory:      "ยังไม่มีประวัติการจอง",
    paidFull:       "✓ ชำระครบ",
    colRoom:        "ห้อง",
    colType:        "ประเภท",
    colCheckIn:     "เช็คอิน",
    colCheckOut:    "เช็คเอาท์",
    colTotal:       "ยอดทั้งหมด",
    colPaid:        "ชำระแล้ว",
    colRemaining:   "คงเหลือ",
    colStatus:      "สถานะ",
    male:           "ชาย",
    female:         "หญิง",
    notSpecified:   "ยังไม่ระบุ",
    defaultUser:    "ชื่อผู้ใช้",

    // ── Profileinfo ──
    profileInfoTitle: "ข้อมูลส่วนตัว",
    genderSelect:   "เพศของคุณ",
    phoneThaiLabel: "เบอร์โทรศัพท์ (ไทย)",
    idCardLabel:    "บัตรประชาชน / พาสปอร์ต",
    saveBtn:        "บันทึก",
    addressPh:      "ที่อยู่ของคุณ",
    countryPh:      "ประเทศของคุณ",
    firstPh:        "ชื่อ",
    lastPh:         "นามสกุล",

    // ── Home ──
    heroDesc:       "ยินดีต้อนรับสู่โรงแรมเอื้องคำเกสท์เฮ้าส์ จังหวัดน่าน ห้องพักราคาประหยัด สะอาด ปลอดภัย ราคาเป็นกันเอง",
    bookRoomBtn:    "จองห้องพัก",
    roomPriceTitle: "ราคาห้องพัก",
    amenitiesNote:  "✦ ห้องพัก 35 ห้อง ✦ เครื่องปรับอากาศ ✦ ทีวี ✦ ตู้เย็น ✦ เครื่องทำน้ำอุ่น ✦ ที่จอดรถ",
    attractionsTitle:"สถานที่ท่องเที่ยว",
    attractionsDesc: "การพักที่โรงแรมเอื้องคำเกสท์เฮ้าส์ ทำให้การเดินทางสะดวกยิ่งขึ้น เนื่องจากตั้งอยู่ใกล้กับสถานที่ท่องเที่ยวสำคัญในจังหวัดน่าน",
    seeInfo:        "ดูข้อมูล ›",
    contactTitle:   "ติดต่อเรา",
    contactHotel:   "โรงแรมเอื้องคำ เกสท์เฮ้าส์",
    contactAddress: "ที่อยู่",
    contactPhone:   "โทรศัพท์",
    contactMobile:  "มือถือ",
    contactWebsite: "เว็บไซต์",
    openInMaps:     "เปิดใน Google Maps",
    roomSingle:     "เตียงเดี่ยว",
    roomDouble:     "เตียงคู่",
    roomSpecial:    "ห้องพักพิเศษ",
    "ห้องพักเตียงเดี่ยว": "ห้องพักเตียงเดี่ยว",
    "ห้องพักเตียงคู่":    "ห้องพักเตียงคู่",
    "ห้องพักสามเตียง":    "ห้องพักสามเตียง",
    "ห้องพักเตียงใหญ่ 1 เล็ก 1": "ห้องพักเตียงใหญ่ 1 เล็ก 1",
    "ห้องพักสี่เตียง":    "ห้องพักสี่เตียง",
    guestsPer:      "คน/ห้อง",
    perNightUnit:   "/คืน",

    // ── OAuthConsent ──
    oauthLoginWith: "เข้าสู่ระบบด้วย",
    oauthTitle:     "ยืนยันข้อตกลงการใช้งาน",
    oauthSubtitle:  "ก่อนเริ่มใช้งาน",
    oauthSubtitle2: "กรุณาอ่านและยอมรับข้อตกลงด้านล่าง",
    oauthReadBtn:   "📄 อ่านข้อตกลงการใช้งานและนโยบายความเป็นส่วนตัว",
    oauthScrollHint:"กรุณาเปิดอ่านและเลื่อนลงจนสุด ก่อนจึงจะสามารถกดยอมรับได้",
    oauthReadAll:   "✓ อ่านครบแล้ว",
    oauthScrollFirst:"กรุณาเลื่อนลงจนสุด",
    oauthAgreeText: "ฉันได้อ่านและยอมรับข้อตกลงการใช้งาน และนโยบายความเป็นส่วนตัวแล้ว",
    acceptBtn:      "ยอมรับ",
    processing:     "กำลังดำเนินการ...",
    acceptAndStart: "✓ ยอมรับและเริ่มใช้งาน",
    cancelAndLeave: "ยกเลิก — ไม่ใช้งาน",
    oauthModalTitle:"ข้อตกลงการใช้งานและนโยบายความเป็นส่วนตัว",

    // ── Payment ──
    scanToTransfer: "สแกนเพื่อโอนเงิน",
    accountNameLabel:"ชื่อบัญชี",
    bankLabel:      "ธนาคาร",
    promptPayLabel: "พร้อมเพย์เบอร์",
    copied:         "✓ คัดลอกแล้ว",
    copyBtn:        "คัดลอก",
    amountLabel:    "จำนวนเงิน",
    depositTag:     "มัดจำ",
    uploadSlipAfter:"หลังโอนเงินแล้ว กรุณาอัปโหลดสลิปด้านล่าง",
    bookingSuccessTitle:"การจองสำเร็จแล้ว!",
    waitingSlipVerify:"รอการตรวจสอบสลิปจากแอดมิน",
    popupCheckIn:   "เช็คอิน",
    popupCheckOut:  "เช็คเอาต์",
    popupNights:    "จำนวนคืน",
    popupRooms:     "จำนวนห้อง",
    popupRoomNos:   "หมายเลขห้อง",
    roomsUnit:      "ห้อง",
    sumLineRooms:   (price, nights, rooms) => `${price} THB × ${nights} คืน × ${rooms} ห้อง`,
    sumLineOne:     (price, nights) => `${price} THB × ${nights} คืน`,
    popupStatus:    "สถานะ",
    pendingReview:  "รอตรวจสอบ",
    paidPopup:      "ชำระแล้ว",
    payAtCounter:   "ชำระที่เคาน์เตอร์",
    partialTag:     "บางส่วน",
    amountDue:      "ยอดที่ต้องชำระ",
    remainingBalance:"ยอดค้าง",
    adminVerify24h: "ทีมแอดมินจะตรวจสอบสลิปและยืนยันการจองภายใน 24 ชั่วโมง",
    cashApprovedSub:  "ยืนยันการจองแล้ว — ชำระเงินที่เคาน์เตอร์",
    cashApprovedBadge:"อนุมัติแล้ว",
    cashApprovedNote: "การจองได้รับการยืนยันแล้ว กรุณาชำระเงินที่เคาน์เตอร์ในวันเช็คอิน",
    cashPendingSub:   "ส่งคำขอจองแล้ว — รอเจ้าหน้าที่ยืนยัน",
    cashPendingNote:  "เจ้าหน้าที่จะยืนยันการจองภายใน 24 ชั่วโมง จากนั้นชำระเงินสดที่เคาน์เตอร์ในวันเช็คอิน",
    newAccountNote: "สร้างบัญชีสมาชิกให้แล้ว กรุณาตรวจสอบอีเมลเพื่อรับรหัสผ่าน",
    acknowledge:    "รับทราบ",
    roomNotFound:   "ไม่พบข้อมูลห้องพัก",
    guestInfoTitle: "ข้อมูลผู้เข้าพัก",
    firstNameLabel: "ชื่อ",
    lastNameLabel:  "นามสกุล",
    customerFirstPh:"ชื่อลูกค้า",
    customerLastPh: "นามสกุลลูกค้า",
    customerEmailPh:"อีเมลลูกค้า",
    customerPhonePh:"เบอร์โทรลูกค้า",
    paymentMethodTitle:"วิธีชำระเงิน",
    payFull:        "ชำระเต็มจำนวน",
    payPartial:     "ชำระบางส่วน (มัดจำ 50%)",
    payCash:        "จ่ายเงินสด",
    payPartialNote: "ยอดมัดจำถูกกำหนดไว้ที่ 50% ของยอดรวม ส่วนที่เหลือชำระที่เคาน์เตอร์ในวันเช็คอิน",
    cashNote:       "ไม่ต้องอัปโหลดสลิป — เจ้าหน้าที่จะยืนยันการจองให้ แล้วชำระเงินที่เคาน์เตอร์ในวันเช็คอิน",
    paymentChannelTitle:"ช่องทางชำระเงิน",
    uploadSlipTitle:"อัปโหลดสลิป",
    clickToSelectSlip:"คลิกเพื่อเลือกไฟล์ภาพสลิป",
    slipFileHint:   "PNG, JPG ขนาดไม่เกิน 5MB",
    changeSlip:     "เปลี่ยนสลิป",
    payNow:         "ชำระตอนนี้",
    amountAtCounter:"ยอดที่ต้องชำระที่เคาน์เตอร์",
    remainingDue:   "ยอดค้างชำระ",
    submitting:     "กำลังส่งข้อมูล...",
    nightsUnit2:    "คืน",

    // ── AdminCalendar ──
    calManageRooms:     "จัดการห้องพัก",
    calRoomColHead:     "ห้อง",
    calDayColHead:      "วัน",
    calRoomType:        "ประเภทของห้อง",
    calRoomStatus:      "สถานะห้อง",
    calAllRooms:        "ทั้งหมด",
    calBookedRooms:     "ห้องที่ถูกจองแล้ว",
    calOccupiedRooms:   "ห้องที่ลูกค้าเข้าพักอยู่",
    calMaintRooms:      "ห้องที่กำลังซ่อมแซม",
    calMonth:           "เดือน",
    calYear:            "ปี",
    calNoRooms:         "🏨 ยังไม่มีข้อมูลห้องพัก",
    calEditPeriod:      "แก้ไขช่วงเวลา",
    calManagePeriod:    "จัดการช่วงเวลา",
    calType:            "ประเภท",
    calStartDate:       "วันเริ่มต้น",
    calEndDate:         "วันสิ้นสุด",
    calColor:           "สี",
    calReason:          "เหตุผล",
    calReasonRequired:  "กรุณาระบุเหตุผล",
    calCancel:          "ยกเลิก",
    calSaving:          "กำลังบันทึก...",
    calSaveEdit:        "บันทึกการแก้ไข",
    calSave:            "บันทึก",
    calDelete:          "🗑️ ลบ",
    calCheckNewIn:      "เช็คอินใหม่",
    calCheckNewOut:     "เช็คเอาต์ใหม่",
    calNights:          "จำนวนคืน",
    calStatus:          "สถานะ",
    calNewTotal:        "ราคารวมใหม่",
    calOldTotal:        "เดิม",
    calChangeDateQ:     "เปลี่ยนวันจอง?",
    calChangeRoomDateQ: "เปลี่ยนห้อง / วันจอง?",
    calGuestName:       "ชื่อแขก",
    calStatusLabel:     "สถานะ",
    calCheckIn:         "เช็คอิน",
    calCheckOut:        "เช็คเอาต์",
    calOccupied:        "ห้องพักไม่ว่าง",
    calMaintenance:     "กำลังซ่อมแซม",
    calOther:           "อื่นๆ",
    calChooseColor:     "เลือกสี",
    calLabelBooked:     "จองห้องแล้ว",
    calLabelCheckedIn:  "ลูกค้าเข้าพักอยู่",
    calLabelCancelled:  "ยกเลิกการจอง",
    calNightSuffix:     "คืน",
    calConfirm:         "ยืนยัน",
    calReasonPh:        "ระบุเหตุผล...",
    calCheckinCount:    "จำนวนการเช็คอิน",
    calAvailCount:      "จำนวนห้องว่าง",
    calBookedCount:     "จำนวนห้องที่ถูกจอง",
    calToastSaved:      "บันทึกการเปลี่ยนแปลงแล้ว ✓",
    calToastSaveFail:   "บันทึกไม่สำเร็จ",
    calToastError:      "เกิดข้อผิดพลาด",
    calToastBlockSaved: "บันทึกช่วงเวลาแล้ว ✓",
    calToastBlockEdited:"แก้ไขช่วงเวลาแล้ว ✓",
    calToastDeleted:    "ลบช่วงเวลาแล้ว ✓",
    calToastDeleteFail: "ลบไม่สำเร็จ",
    calToastConnErr:    "เชื่อมต่อ server ไม่ได้",
    calTabBooking:      "จองห้อง",
    calTabBlock:        "บล็อกห้อง",
    calBkGuestName:     "ชื่อผู้เข้าพัก",
    calBkGuestNamePh:   "เช่น สมชาย ใจดี",
    calBkPhone:         "เบอร์โทร",
    calBkPhonePh:       "08X-XXX-XXXX",
    calBkPayment:       "การชำระเงิน",
    calBkPaidFull:      "จ่ายเต็มจำนวน",
    calBkPaidPartial:   "ชำระบางส่วน",
    calBkPaidNone:      "ยังไม่ชำระ",
    calBkPartialAmt:    "ยอดที่ชำระ (บาท)",
    calBkRemain:        "คงเหลือ",
    calBkErrPartial:    "ยอดที่ชำระต้องมากกว่า 0 และไม่เกินยอดรวม",
    calBkCheckInNow:    "เช็คอินเลย",
    calBkCheckInHint:   "จะพาไปกรอกข้อมูลผู้เข้าพักต่อ · บันทึกลงระบบเมื่อกดยืนยันเช็คอินสำเร็จเท่านั้น",
    calBkTotal:         "ยอดรวม",
    calBkSubmit:        "ยืนยันการจอง",
    calBkSubmitting:    "กำลังจอง...",
    calBkErrDate:       "วันเช็คเอาต์ต้องหลังวันเช็คอิน อย่างน้อย 1 คืน",
    calBkErrOverlap:    "ห้องนี้ไม่ว่างในช่วงวันที่เลือก",
    calBkErrNoRoom:     "กรุณาเลือกห้องอย่างน้อย 1 ห้อง",
    calBkErrNamePerRoom:"กรุณากรอกชื่อผู้เข้าพักให้ครบทุกห้อง",
    calBkSameGuest:     "ใช้ชื่อเดียวกันทุกห้อง",
    calBkSameGuestOn:   "ผู้เข้าพักคนเดียวจองหลายห้อง กรอกชื่อครั้งเดียว",
    calBkSameGuestOff:  "กรอกชื่อผู้เข้าพักแยกในแต่ละห้องด้านบน",
    calDragHint:        "กดที่ช่องว่างแล้วลากเพื่อเลือกช่วงวัน",
    calRoomsUnit:       "ห้อง",
    calBkRoomList:      "ห้องที่เลือก",
    calBkRoomBusy:      "ไม่ว่างในช่วงนี้",
    calMultiStart:      "จองหลายห้อง",
    calMultiExit:       "ออกจากโหมดเลือก",
    calMultiSelectAll:  "เลือกห้องว่างทั้งหมด",
    calMultiClear:      "ล้างที่เลือก",
    calMultiSetAll:     "ตั้งวันให้ทุกห้อง",
    calMultiMixedDates: "⚡ แต่ละห้องวันไม่เหมือนกัน",
    calMultiConflict:   (rooms) => `⛔ ห้อง ${rooms} ทับการจองอื่น`,
    calMultiPicked:     (n) => `เลือกแล้ว ${n} ห้อง`,
    calMultiBook:       (n) => `จอง ${n} ห้อง →`,
    calBkToastGroupOk:  (n, rooms) => `จอง ${n} ห้องสำเร็จ ✓ (${rooms})`,
    calBkErrName:       "กรุณากรอกชื่อผู้เข้าพัก",
    calBkPhoneOpt:      "ไม่บังคับ",
    calCancelBkBtn:     "ยกเลิกการจอง",
    calNextSlip:        "ตรวจสอบสลิป →",
    calNextCheckIn:     "ไปเช็คอิน →",
    calNextCheckOut:    "ไปเช็คเอาท์ →",
    calCancelBkConfirm: "ยืนยันยกเลิกการจองนี้? ห้องจะกลับมาว่างทันที และย้อนกลับไม่ได้",
    calCancelBkReasonPh:"เหตุผล (ไม่บังคับ)",
    calCancelBkYes:     "ยืนยันยกเลิก",
    calCancelBkBack:    "ย้อนกลับ",
    calCancelBkBusy:    "กำลังยกเลิก...",
    calCancelBkOk:      "ยกเลิกการจองสำเร็จ",
    calCancelBkLocked:  "การจองนี้ยกเลิกไม่ได้ (เช็คเอาท์หรือยกเลิกไปแล้ว)",
    calBkToastOk:       "จองห้อง {room} สำเร็จ ✓",
    calZoomOut:         "ย่อ",
    calZoomIn:          "ขยาย",
    calBackToMonth:     "กลับดูทั้งเดือน",
    calNightsUnit:      "คืน",
    calDue:             "ค้าง",
    calPaidFull:        "ชำระครบ",
    calWalkIn:          "Walk-in",
    calPrevDay:         "วันก่อนหน้า",
    calNextDay:         "วันถัดไป",
    calDayViewHint:     "คลิกเพื่อดูรายวัน",
    calTypeSingle:      "เดี่ยว",
    calTypeDouble:      "คู่",
    calTypeFamily:      "ใหญ่+เล็ก",
    calTypeTriple:      "3 เตียง",
    calTypeQuad:        "4 เตียง",

    // ── AdminDashboard ──
    dbRevenueAccYear:   "รวม • ปี",
    dbBookings:         "การจอง",
    dbStatusPending:    "รอตรวจสอบ",
    dbStatusApproved:   "อนุมัติแล้ว",
    dbStatusConfirmed:  "ยืนยันแล้ว",
    dbStatusCheckedIn:  "เช็คอินแล้ว",
    dbStatusCheckedOut: "เช็คเอาท์แล้ว",
    dbStatusCancelled:  "ยกเลิก",
    dbNewBooking:       "จองใหม่ —",
    dbPayment:          "ชำระเงิน",
    dbMinAgo:           "นาทีก่อน",
    dbHrsAgo:           "ชม.ก่อน",
    dbYesterday:        "เมื่อวาน",
    dbDashboard:        "แดชบอร์ด",
    dbRevenueYear:      "รายได้รวม (ปี)",
    dbRevenueMonth:     "รายได้ (เดือนนี้)",
    dbRevenueDay:       "รายได้ (วันนี้)",
    dbTotalGuests:      "ผู้เข้าพักทั้งหมด",
    dbRefresh:          "⟳ รีเฟรช",
    dbMonthlyRevenue:   "รายได้รายเดือน",
    dbThisYear:         "ปีนี้",
    dbLastYear:         "ปีที่แล้ว",
    dbCheckins:         "เข้าพัก",
    dbRoomUsage:        "การใช้ห้อง",
    dbNoBookings:       "ยังไม่มีการจอง",
    dbNoGuests:         "ยังไม่มีลูกค้าจองห้อง",
    dbRecentBookings:   "การจองล่าสุด",
    dbNotifications:    "แจ้งเตือนของระบบ",
    dbNoNotifs:         "ไม่มีการแจ้งเตือน",
    dbBookingStatus:    "สถานะการจอง",
    dbMonthly:          "รายเดือน",
    dbWeekly:           "รายสัปดาห์",

    // ── GuestRegistry (ทะเบียนลูกค้า + วิเคราะห์) ──
    grTitle:            "ทะเบียนลูกค้า",
    grSub:              "ข้อมูลผู้เข้าพัก ประวัติการเข้าพัก และรายงานวิเคราะห์กลุ่มลูกค้า",
    grTabRegistry:      "ทะเบียนลูกค้า",
    grTabAnalytics:     "วิเคราะห์",
    grSearch:           "ค้นหา",
    grSearchPh:         "ชื่อ / เลขบัตร / เบอร์โทร / บริษัท / ทะเบียนรถ",
    grType:             "ประเภทผู้เข้าพัก",
    grTypeAll:          "ทุกประเภท",
    grFrom:             "เข้าพักตั้งแต่",
    grTo:               "ถึง",
    grLoad:             "ค้นหา",
    grLoading:          "กำลังโหลด...",
    grExport:           "⬇️ ดาวน์โหลด Excel",
    grExporting:        "กำลังสร้างไฟล์...",
    grExportOk:         "ดาวน์โหลดไฟล์เรียบร้อย",
    grExportFail:       "สร้างไฟล์ไม่สำเร็จ",
    grQuickRange:       "ช่วงเวลา:",
    grRangeAll:         "ทั้งหมด",
    grRange12m:         "±1 ปี",
    grRangeThisY:       "ปีนี้",
    grRangeLastY:       "ปีที่แล้ว",
    grFilterNote:       "เว้นวันที่ว่างไว้ = ดูทั้งหมด · ช่วงวันที่กรองจาก “วันที่เข้าพัก” และแท็บวิเคราะห์ใช้ช่วงเดียวกัน",
    grLoadFail:         "โหลดข้อมูลไม่สำเร็จ",
    grSaveFail:         "บันทึกไม่สำเร็จ",
    grSaved:            "บันทึกเรียบร้อย",
    grEmpty:            "ยังไม่มีลูกค้าในทะเบียน",
    grNoData:           "ไม่พบข้อมูลในช่วงเวลาที่เลือก",
    grStatGuests:       "จำนวนลูกค้า",
    grStatStays:        "จำนวนการเข้าพัก",
    grStatDue:          "ค้างชำระรวม",
    grStatRevenue:      "รายได้รวม (บาท)",
    grStatAvgNights:    "คืนเฉลี่ย/ครั้ง",
    grStatAvgSpend:     "ใช้จ่ายเฉลี่ย/ครั้ง",
    grStatNewGuest:     "ลูกค้าใหม่ / กลับมาซ้ำ",
    grStatCar:          "มีรถ / ไม่มีรถ",
    grStatChannel:      "หน้าเคาน์เตอร์ / ออนไลน์",
    grColName:          "ชื่อ-สกุล",
    grColType:          "ประเภท",
    grColIdCard:        "เลขบัตร/พาสปอร์ต",
    grColPhone:         "เบอร์โทร",
    grColCompany:       "บริษัท",
    grColCar:           "ทะเบียนรถ",
    grColStays:         "เข้าพัก (ครั้ง)",
    grColLastStay:      "เข้าพักล่าสุด",
    grColTotal:         "ยอดรวมสะสม",
    grColDue:           "ค้างชำระ",
    grColNights:        "คืน",
    grColNote:          "หมายเหตุ",
    grEdit:             "แก้ไข",
    grSave:             "บันทึก",
    grSaving:           "กำลังบันทึก...",
    grCancel:           "ยกเลิก",
    grSecIdentity:      "ข้อมูลส่วนตัว",
    grSecNote:          "หมายเหตุภายใน",
    grSecHistory:       "ประวัติการเข้าพักทั้งหมด",
    grDetailStays:      (n) => `เข้าพักมาแล้ว ${n} ครั้ง`,
    grDetailPaid:       "ชำระแล้วรวม",
    grDetailFirst:      "เข้าพักครั้งแรก",
    grChartMix:         "สัดส่วนประเภทผู้เข้าพัก",
    grChartMixSub:      "พนักงานบริษัท เทียบกับ นักท่องเที่ยว และกลุ่มอื่นๆ",
    grChartRevenue:     "รายได้แยกตามประเภทผู้เข้าพัก",
    grChartRevenueSub:  "กลุ่มไหนสร้างรายได้มากที่สุด",
    grChartMonthly:     "จำนวนการเข้าพักรายเดือน แยกตามประเภท",
    grChartMonthlySub:  "ใช้ดูว่านักท่องเที่ยวพีคเดือนไหน และแต่ละเดือนมีพนักงานบริษัทเข้าพักกี่ราย",
    grChartCompanies:   "10 บริษัทที่เข้าพักบ่อยที่สุด",
    grChartCompaniesSub:"ลูกค้าองค์กรรายสำคัญ",
    grChartProvince:    "ต้นทางลูกค้า (จังหวัดทะเบียนรถ)",
    grChartProvinceSub: "ใช้เลือกพื้นที่ทำการตลาด",
    grProvinceCaveat:   "หมายเหตุ: รถเช่าและรถบริษัทอาจจดทะเบียนคนละจังหวัดกับที่ลูกค้าอยู่จริง เหมาะใช้ดูแนวโน้มภาพรวม ไม่ควรใช้ตัดสินรายบุคคล",
    grUnitStays:        "ครั้ง",
    grUnitBaht:         "บาท",

    // ── AdminReport ──
    rptLoadFail:        "โหลดข้อมูลไม่สำเร็จ",
    rptTitle:           "📊 สร้างรายงานการเข้าพัก",
    rptSub:             "ดึงข้อมูลจากการเข้าพักที่เช็คเอาต์แล้ว",
    rptSelectMonth:     "📅 เลือกเดือน",
    rptNMonths:         "🔢 จำนวนเดือน",
    rptDateRange:       "🗓️ ช่วงวันที่",
    rptMonth:           "เดือน",
    rptYear:            "ปี (พ.ศ.)",
    rptNMonthsBack:     "ย้อนหลัง (เดือน)",
    rptDateFrom:        "ตั้งแต่วันที่",
    rptDateTo:          "ถึงวันที่",
    rptSearchGuest:     "🔍 กรองตามชื่อ / อีเมลผู้เข้าพัก",
    rptSearchPh:        "ค้นหาผู้เข้าพัก...",
    rptLoad:            "โหลดข้อมูล",
    rptLoading:         "⏳ โหลด...",
    rptTotal:           "ทั้งหมด",
    rptItems:           "รายการ",
    rptRevenue:         "รายได้รวม",
    rptDownload:        "⬇️ ดาวน์โหลด Excel",
    rptNoData:          "ไม่พบข้อมูลในช่วงเวลาที่เลือก",
    rptColNum:          "#",
    rptColGuest:        "ชื่อผู้เข้าพัก",
    rptColEmail:        "อีเมล",
    rptColRoom:         "ห้อง",
    rptColType:         "ประเภท",
    rptColCheckIn:      "เช็คอิน",
    rptColCheckOut:     "เช็คเอาต์",
    rptColNights:       "คืน",
    rptColTotal:        "ราคารวม",
    rptColPaid:         "ชำระแล้ว",
    rptDaily:           "📆 รายงานรายวัน (ทุกห้อง)",
    rptDailyDate:       "เลือกวันที่",
    rptColPhone:        "เบอร์โทร",
    rptColRemain:       "คงเหลือ",
    rptColRoomNo:       "เลขห้อง",
    rptColRoomStatus:   "สถานะห้อง",
    rptVacant:          "ห้องว่าง",
    rptOccupied:        "ไม่ว่าง",
    rptRoomsTotal:      "ห้องทั้งหมด",
    rptRoomsOccupied:   "ห้องไม่ว่าง",
    rptRoomsVacant:     "ห้องว่าง",
    rptOutstanding:     "ยอดค้างชำระ",

    // ── AdminRooms ──
    arRoomNameThPh:     "เช่น ห้องดับเบิ้ลเบด",
    arRoomDescPh:       "อธิบายสิ่งอำนวยความสะดวก, วิว, ขนาดห้อง ฯลฯ",
    arDefaultNightsPh:  "เช่น 2 คืน",
    arTitle:            "จัดการห้องพัก",
    arRooms:            "ห้อง",
    arRefresh:          "รีเฟรช",
    arSearch:           "ค้นหาห้องพัก...",
    arAddRoom:          "เพิ่มห้องพัก",
    arAll:              "ทั้งหมด",
    arEditRoom:         "แก้ไขข้อมูลห้องพัก",
    arAddNewRoom:       "เพิ่มห้องพักใหม่",
    arBasicInfo:        "ข้อมูลพื้นฐาน",
    arRoomNameTh:       "ชื่อห้องพัก (ภาษาไทย)",
    arRoomType:         "ประเภทห้อง",
    arRoomNameEn:       "ชื่อห้องพัก (ภาษาอังกฤษ)",
    arRoomNameEnNote:   "— แสดงเมื่อผู้ใช้เปลี่ยนเป็นภาษาอังกฤษ",
    arRoomDesc:         "รายละเอียดห้องพัก",
    arCapacity:         "ความจุ",
    arMaxAdults:        "ผู้ใหญ่สูงสุด",
    arMaxChildren:      "เด็กสูงสุด",
    arBeds:             "เตียงในห้อง",
    arBedsNote:         "— ขนาดเตียง (ฟุต) และจำนวน เพิ่มได้หลายขนาด",
    arBedFt:            "ฟุต",
    arBedUnit:          "เตียง",
    arAddBed:           "+ เพิ่มเตียง",
    arBedsEmpty:        "ยังไม่ได้ระบุเตียง — หน้ารายละเอียดห้องจะไม่แสดงข้อมูลเตียง",
    arBedsPreview:      "จะแสดงเป็น:",
    arDefaultNights:    "จำนวนคืน (ค่าเริ่มต้น)",
    arUnits:            "ยูนิตห้องพัก",
    arUnitPrefix:       "ตัวอักษรนำหน้า (A, B, C…)",
    arUnitCount:        "จำนวนห้อง",
    arRoomNumbers:      "🏨 เลขห้องจะเป็น:",
    arManualUnitsNote:  "🔒 เลขห้องของประเภทนี้กำหนดเองตามผังจริง (เช่น 1, V2, 301) — แก้ไขจำนวน/เลขห้องจากหน้านี้ไม่ได้",
    arManualEditHint:   "กำหนดเลขห้องเองตามผังจริง (เช่น 1, V2, 301) — เพิ่ม แก้ หรือลบได้ทีละห้อง",
    arUnitNumber:       "เลขห้อง",
    arUnitNumberPh:     "เช่น 101, V2, 301",
    arAddUnit:          "+ เพิ่มห้อง",
    arUnitsShow:        "แสดงเลขห้อง",
    arUnitsHide:        "ซ่อนเลขห้อง",
    arUnitModeAuto:     "สร้างเลขอัตโนมัติ",
    arUnitModeManual:   "กำหนดเลขเอง",
    arUnitNeedOne:      "กรุณาระบุเลขห้องอย่างน้อย 1 ห้อง",
    arUnitBooked:       "มีการจอง",
    arUnitLoadFail:     "โหลดเลขห้องไม่สำเร็จ",
    arPricing:          "ราคา",
    arRoomPrice:        "ราคาห้องพัก (บาท)",
    arFilterPrice:      "ราคาสำหรับตัวกรอง",
    arOptions:          "ตัวเลือกเพิ่มเติม",
    arBreakfast:        "รวมอาหารเช้า",
    arPhoto:            "รูปภาพห้องพัก (รูปหลัก)",
    arPhotoExtra:       "รูปเพิ่มเติม",
    arPhotoExtraNote:   "เลือกได้หลายรูป (สูงสุด 12 รูป)",
    arPhotoRemove:      "ลบรูปนี้",
    arSaveEdit:         "บันทึกการแก้ไข",
    arAddRoomBtn:       "เพิ่มห้องพัก",
    arCancelBtn:        "ยกเลิก",
    arDeleteConfirm:    "ยืนยันการลบห้องพัก",
    arDeleteDesc:       "ลบห้องพัก",
    arDeleteWarn:       "การกระทำนี้ไม่สามารถย้อนกลับได้",
    arDeleteBtn:        "ลบห้องพัก",
    arDeleting:         "กำลังลบ…",
    arToastLoadFail:    "โหลดข้อมูลไม่สำเร็จ",
    arToastEditOk:      "แก้ไขห้องพักสำเร็จ",
    arToastAddOk:       "เพิ่มห้องพักสำเร็จ",
    arToastSaveFail:    "บันทึกข้อมูลไม่สำเร็จ",
    arToastDeleteOk:    "ลบห้องสำเร็จ",
    arNoRooms:          "ยังไม่มีห้องพักในระบบ",
    arNoSearch:         "ไม่พบห้องพักที่ตรงกับคำค้นหา",
    arEdit:             "แก้ไข",
    arDelete:           "ลบ",
    arBreakfastBadge:   "🍳 อาหารเช้า",
    arAdults:           "👤 ผู้ใหญ่",
    arPerson:           "คน",
    arChildren:         "👦 เด็ก",
    arPerNight:         "/ คืน",
    arUnitsLabel:       "ยูนิต",

    // ── AdminPayments ──
    pymTitle:           "ตรวจสอบการชำระเงิน",
    pymRoom:            "ห้อง",
    pymEmail:           "อีเมล",
    pymAmount:          "จำนวนเงิน",
    pymStatus:          "สถานะ",
    pymApprove:         "อนุมัติ",
    pymReject:          "ปฏิเสธ",

    // ── Admincancellationpage ──
    cancLoadFail:       "โหลดข้อมูลไม่สำเร็จ",
    cancActionFail:     "ดำเนินการไม่สำเร็จ",
    cancTitle:          "คำขอยกเลิกการจอง",
    cancSub:            "พิจารณาและตอบรับคำขอยกเลิกจากลูกค้า",
    cancPending:        "รอพิจารณา",
    cancApproved:       "อนุมัติแล้ว",
    cancRejected:       "ปฏิเสธแล้ว",
    cancLoading:        "กำลังโหลด...",
    cancNoItems:        "ไม่มีคำขอในสถานะนี้",
    cancColGuest:       "ผู้จอง",
    cancColRoom:        "ห้องพัก",
    cancColCheckIn:     "วันเช็คอิน",
    cancColTotal:       "ยอดรวม",
    cancColRequested:   "ยื่นคำขอ",
    cancColStatus:      "สถานะ",
    cancReview:         "พิจารณา",
    cancViewDetail:     "ดูรายละเอียด",
    cancModalTitle:     "พิจารณาคำขอยกเลิก",
    cancBookingInfo:    "ข้อมูลการจอง",
    cancGuest:          "ผู้จอง",
    cancRoom:           "ห้องพัก",
    cancCheckIn:        "วันเช็คอิน",
    cancCheckOut:       "วันเช็คเอาท์",
    cancTotal:          "ยอดรวม",
    cancReason:         "เหตุผลของลูกค้า",
    cancNoReason:       "ไม่ได้ระบุเหตุผล",
    cancRefund:         "ยอดคืนเงิน (บาท)",
    cancNote:           "หมายเหตุถึงลูกค้า (ถ้ามี)",
    cancNotePh:         "เช่น คืนเงินภายใน 3-5 วันทำการ...",
    cancCancelBtn:      "ยกเลิก",
    cancRejectBtn:      "ปฏิเสธคำขอ",
    cancApproveBtn:     "อนุมัติการยกเลิก",
    cancProcessing:     "กำลังดำเนินการ...",
    cancResult:         "ผลการพิจารณา",
    cancDecisionStatus: "สถานะ",
    cancRefundAmt:      "ยอดคืนเงิน",
    cancNoRefund:       "ไม่มีการคืนเงิน",
    cancActionDate:     "ดำเนินการเมื่อ",
    cancNoteLabel:      "หมายเหตุ",
    cancClose:          "ปิด",
    // ── แอดมินยกเลิกเอง ──
    cancAdminNewBtn:    "ยกเลิกการจองเอง",
    cancAdminTitle:     "เลือกการจองที่จะยกเลิก",
    cancAdminSub:       "เฉพาะห้องที่มีการจองหรือเช็คอินแล้วเท่านั้น",
    cancAdminNoActive:  "ไม่มีการจองที่ยกเลิกได้ในขณะนี้",
    cancAdminPick:      "เลือกยกเลิก",
    cancAdminConfirmTitle: "ยืนยันการยกเลิกการจอง",
    cancAdminReason:    "เหตุผลการยกเลิก",
    cancAdminReasonPh:  "เช่น ลูกค้าแจ้งยกเลิกทางโทรศัพท์...",
    cancAdminConfirmBtn:"ยืนยันการยกเลิก",
    cancAdminBooked:    "จองแล้ว",
    cancAdminCheckedIn: "เช็คอินแล้ว",
    cancAdminSuccess:   "ยกเลิกการจองสำเร็จ",

    // ── CheckIn / CheckOut shared ──
    ciUnknownName:      "ไม่ระบุชื่อ",
    ciDefaultRoom:      "ห้องธรรมดา",

    // ── CheckIn ──
    ciTitle:            "เช็คอิน",
    ciBack:             "กลับ",
    ciIdCard:           "เลขบัตรประชาชน / หนังสือเดินทาง",
    ciIdCardPh:         "กรอกเลขบัตร / หนังสือเดินทาง",
    ciReadCard:         "อ่านบัตรประชาชน",
    ciReadingCard:      "กำลังอ่านบัตร...",
    ciReadCardOk:       "อ่านบัตรประชาชนสำเร็จ",
    ciReadCardHint:     "เสียบบัตรในเครื่องอ่าน แล้วกดปุ่มเพื่อกรอกข้อมูลอัตโนมัติ",
    ciAgentOffline:     "เชื่อมต่อตัวอ่านบัตรไม่ได้ — กรุณาเปิดโปรแกรม ID Card Agent บนเครื่องนี้",
    ciAgentOnline:      "เครื่องอ่านบัตรพร้อมใช้งาน",
    ciAgentOfflineShort:"เครื่องอ่านบัตรออฟไลน์",
    ciAgentChecking:    "กำลังตรวจสอบเครื่องอ่านบัตร...",
    ciAgentNoReader:    "ไม่พบเครื่องอ่านบัตร — กรุณาเสียบเครื่องอ่าน",
    ciAgentNoPcsc:      "ระบบอ่านบัตร (PC/SC) ไม่พร้อมใช้งาน",
    ciAgentCardIn:      "พบบัตร — พร้อมอ่าน",
    ciAgentCheckFail:   "ตรวจสอบเครื่องอ่านบัตรไม่สำเร็จ",
    ciOcrPick:          "อ่านข้อมูลจากรูปบัตร (ไม่เก็บรูปไว้)",
    ciOcrReading:       "กำลังอ่านข้อมูลจากรูป...",
    ciOcrOk:            (n) => `อ่านรูปบัตรสำเร็จ — กรอกให้ ${n} ช่อง กรุณาตรวจสอบความถูกต้อง`,
    ciOcrDone:          "อ่านข้อมูลจากรูปแล้ว — ไม่ได้เก็บรูปไว้",
    ciOcrNone:          "อ่านตัวหนังสือได้ แต่จับรูปแบบบัตรไม่ได้ — กรุณากรอกเอง",
    ciOcrUnreadable:    "รูปไม่ชัดพอ — ถ่ายให้บัตรเต็มเฟรม แสงสม่ำเสมอ ไม่มีเงา แล้วลองใหม่",
    ciOcrFail:          "เกิดข้อผิดพลาดขณะอ่านรูป — กรุณากรอกเอง",
    ciFieldName:        "ชื่อ",
    ciFieldAddress:     "ที่อยู่",
    ciFieldBirthDate:   "วันเกิด",
    ciFieldGender:      "เพศ",
    ciFieldCountry:     "ประเทศ",
    ciFieldNationality: "สัญชาติ",
    ciFieldPhone:       "หมายเลขโทรศัพท์",
    ciFieldExtra:       "ข้อมูลเพิ่มเติม",
    ciGenderSelect:     "-- เลือกเพศ --",
    ciGenderM:          "ชาย",
    ciGenderF:          "หญิง",
    ciGenderOther:      "เพศทางเลือก",
    ciGenderNA:         "ไม่ระบุ",
    ciBookingDetail:    "รายละเอียดการจองห้องพัก",
    ciRoomFor:          "ห้องสำหรับ",
    ciPersons:          "คน",
    ciBookedOn:         "จองเมื่อ",
    ciCheckIn:          "เช็คอิน",
    ciCheckOut:         "เช็คเอาท์",
    ciTotalPrice:       "ราคาทั้งหมด",
    ciPaid:             "ชำระแล้ว",
    ciBalanceDue:       "ยอดค้างชำระ",
    ciBalance:          "ยอดคงเหลือ",
    ciPaidFull:         "ชำระครบแล้ว ✓",
    ciPay:              "ชำระเงิน",
    ciNoImage:          "ไม่มีรูปภาพ",
    ciPayTitle:         "💳 รับชำระเงิน",
    ciAmountDue:        "ยอดค้างชำระ",
    ciCash:             "เงินสด",
    ciScanPay:          "สแกนเพื่อชำระ",
    ciCancelBtn:        "ยกเลิก",
    ciConfirmBtn:       "ยืนยัน",
    ciConfirming:       "กำลังดำเนินการ...",
    ciSearchPh:         "ค้นหาลูกค้า / ห้อง",
    // ── มุมมองวันนี้ / ทั้งหมด ──
    ciTabToday:         "เข้าวันนี้",
    ciTabAll:           "ทั้งหมด",
    coTabToday:         "ออกวันนี้",
    coTabAll:           "ทั้งหมด",
    // ── จองด่วนหน้าเคาน์เตอร์ (Walk-in) ──
    wiNewBtn:           "จองเข้าพักใหม่",
    wiTitle:            "จองด่วนหน้าเคาน์เตอร์",
    wiSub:              "สำหรับลูกค้าที่เดินเข้ามาจองที่เคาน์เตอร์",
    wiRoomType:         "ประเภทห้อง",
    wiRoomTypePh:       "เลือกประเภทห้อง",
    wiCheckIn:          "วันเช็คอิน",
    wiCheckOut:         "วันเช็คเอาท์",
    wiGuestName:        "ชื่อผู้เข้าพัก",
    wiGuestNamePh:      "ชื่อ-นามสกุล",
    wiPhone:            "เบอร์โทร",
    wiPhonePh:          "เบอร์ติดต่อ (ถ้ามี)",
    wiNights:           "จำนวนคืน",
    wiTotal:            "ยอดรวม",
    wiPayMethod:        "วิธีชำระ",
    wiCash:             "เงินสด",
    wiPaidAmount:       "รับชำระแล้ว",
    wiPayFull:          "จ่ายเต็ม",
    wiPayNone:          "ยังไม่ชำระ",
    wiSubmit:           "สร้างการจอง",
    wiSubmitting:       "กำลังสร้าง...",
    wiSuccess:          "จองสำเร็จ",
    wiCancelBtn:        "ยกเลิก",
    wiErrRoom:          "กรุณาเลือกประเภทห้อง",
    wiErrDate:          "วันเช็คเอาท์ต้องหลังวันเช็คอิน",
    ciLoadingData:      "กำลังโหลดข้อมูล...",
    ciNoList:           "ไม่มีรายการรอเช็คอิน",
    ciErrBadData:       "รูปแบบข้อมูลไม่ถูกต้อง",
    ciErrConnect:       "เชื่อมต่อ server ไม่ได้",
    ciToastCheckinOk:   "เช็คอินสำเร็จ ✓",
    ciToastCheckinFail: "เช็คอินไม่สำเร็จ กรุณาลองใหม่",
    ciLoadFail:         "โหลดข้อมูลไม่สำเร็จ:",
    ciRoomLabel:        "ห้อง",
    ciCheckinBtn:       "เช็คอิน",
    ciAge:              "อายุ :",
    ciReceivedCash:     "รับชำระเงินสด",
    ciReceivedQR:       "รับชำระผ่าน QR Code",
    ciUndo:             "ย้อนกลับ",
    ciOk:               "ยืนยัน",

    // ── เช็คอินหลายห้องที่จองมาพร้อมกัน (groupId เดียวกัน) ──
    ciGroupRooms:       (n) => `จองพร้อมกัน ${n} ห้อง`,
    ciGroupStep:        (i, n) => `กำลังกรอกห้องที่ ${i} จาก ${n}`,
    ciGroupHint:        "กรอกผู้เข้าพักให้ครบทุกห้อง แล้วกดยืนยันครั้งเดียว",
    ciGroupBookedBy:    "ผู้จอง :",
    ciPrevRoom:         "ห้องก่อนหน้า",
    ciNextRoom:         "ห้องถัดไป",
    ciConfirmAll:       (n) => `ยืนยันเช็คอิน ${n} ห้อง`,
    ciGroupTotal:       (n) => `ยอดรวมทั้งกลุ่ม (${n} ห้อง)`,
    ciRoomPrice:        "ราคาห้องนี้",
    ciCopyPrev:         "คัดลอกข้อมูลจากห้องก่อนหน้า",
    ciCopiedPrev:       "คัดลอกข้อมูลแล้ว ✓",
    ciGroupCheckedIn:   (n) => `เช็คอินสำเร็จ ${n} ห้อง ✓`,
    ciGroupPartialFail: (n) => `เช็คอินไม่สำเร็จ ${n} ห้อง กรุณาลองใหม่`,

    // ── จองจากปฏิทินแบบ "เช็คอินเลย" — ยังไม่บันทึกจนกว่าจะยืนยันสำเร็จ ──
    ciDraftBanner:      "ยังไม่ได้บันทึกการจองนี้ — ระบบจะบันทึกเมื่อกดยืนยันเช็คอินสำเร็จเท่านั้น",
    ciDraftNotSaved:    "ยังไม่บันทึก",
    ciDraftLeaveConfirm:"ออกโดยไม่บันทึก? การจองนี้จะไม่ถูกสร้าง และข้อมูลที่กรอกไว้จะหายทั้งหมด",
    ciDraftFail:        "เช็คอินไม่สำเร็จ ระบบไม่ได้บันทึกการจองนี้ ข้อมูลที่กรอกยังอยู่ กดยืนยันใหม่ได้",

    // ── CheckIn: ช่องที่เจ้าหน้าที่กรอกเพิ่ม + ประวัติการเข้าพัก ──
    // กรอกได้ทั้ง staff และ admin (route /checkin เปิดให้ทั้งสอง role)
    ciAdminSection:     "ข้อมูลเพิ่มเติม",
    ciAdminSectionSub:  "ใช้ออกใบเสร็จและทำรายงานวิเคราะห์ลูกค้า",
    ciGuestType:        "ประเภทผู้เข้าพัก",
    ciTypeAuto:         "ค่าที่ระบบแนะนำจากข้อมูลที่กรอก — เลือกเองเพื่อแก้ไข",
    ciStayPurpose:      "วัตถุประสงค์การเข้าพัก",
    ciPurposeSelect:    "-- เลือกวัตถุประสงค์ --",
    ciCompanyGroup:     "ข้อมูลบริษัท",
    ciCompanyName:      "ชื่อบริษัท",
    ciCompanyAddress:   "ที่อยู่บริษัท",
    ciCompanyBranchNo:  "สาขาเลขที่",
    ciCompanyTaxId:     "หมายเลขผู้เสียภาษี",
    ciCarGroup:         "ข้อมูลรถยนต์",
    ciCarNote:          "ไม่แสดงในใบเสร็จ — เก็บเป็นประวัติและใช้วิเคราะห์ที่มาของลูกค้า",
    ciCarBrand:         "ยี่ห้อรถ",
    ciCarColor:         "สีรถ",
    ciCarPlate:         "ทะเบียนรถ",
    ciCarProvince:      "จังหวัดที่จดทะเบียน",
    ciProvinceSearchPh: "พิมพ์เพื่อค้นหาจังหวัด",
    ciLookingUp:        "กำลังค้นทะเบียนลูกค้า...",
    ciReturningGuest:   "ลูกค้าเก่า",
    ciStayCount:        (n) => `เคยเข้าพัก ${n} ครั้ง`,
    ciHistTitle:        "ประวัติการเข้าพักครั้งก่อนๆ",
    ciHistSub:          "ข้อมูลจากทะเบียนลูกค้า — แสดง 10 ครั้งล่าสุด",
    ciHistDate:         "วันที่เข้าพัก",
    ciHistRoom:         "ห้อง",
    ciHistType:         "ประเภท",
    ciHistTotal:        "ยอดรวม",
    ciHistPaid:         "ชำระแล้ว",
    ciHistDue:          "ค้างชำระ",
    ciHistMethod:       "วิธีชำระ",
    ciHistOutstanding:  "ค้างชำระรวม",

    // ── CheckOut ──
    coTitle:            "เช็คเอ้าท์",
    coBack:             "กลับ",
    coPayment:          "การชำระเงิน",
    coRoomPrice:        "ราคาห้อง",
    coRoomPaid:         "ชำระแล้ว",
    coExtraItems:       "รายการเพิ่มเติม",
    coAddItem:          "เพิ่มรายการ",
    coQty:              "จำนวน",
    coBalanceDue:       "ยอดค้างชำระ",
    coBalancePaid:      "ยอดคงเหลือ",
    coPaidFull:         "ชำระครบแล้ว ✓",
    coPayBtn:           "ชำระเงิน",
    coNoImage:          "ไม่มีรูปภาพ",
    coBookingDetail:    "รายละเอียดการจองห้องพัก",
    coGuests:           "จำนวนคน",
    coBookedOn:         "จองเมื่อ",
    coCheckIn:          "เช็คอิน",
    coCheckOut:         "เช็คเอาท์",
    coTotalPrice:       "ราคาทั้งหมด",
    coPaidLabel:        "ชำระแล้ว",
    coTotalDue:         "ยอดค้างชำระ",
    coConfirm:          "ยืนยัน",
    coConfirming:       "กำลังดำเนินการ...",
    coPayWarn:          "⚠️ กรุณาชำระเงินก่อนยืนยันเช็คเอาท์",
    coSearchPh:         "ค้นหาลูกค้า / ห้อง",
    coLoadingData:      "กำลังโหลดข้อมูล...",
    coToastLoadFail:    "โหลดข้อมูลไม่สำเร็จ",
    coToastPayCash:     "รับชำระเงินสด",
    coToastPayQR:       "รับชำระผ่าน QR",
    coToastPaySuffix:   "บาท เรียบร้อย ✓",
    coToastCheckoutOk:  "เช็คเอาท์สำเร็จ ✓ ส่งใบเสร็จทางเมลแล้ว",
    coToastCheckoutFail:"เช็คเอาท์ไม่สำเร็จ",
    coNoList:           "ไม่มีรายการรอเช็คเอาท์",
    coCustomer:         "ชื่อลูกค้า :",
    coCheckoutBtn:      "เช็คเอาท์",
    coLate:             "เกิน",
    coPayTitle:         "💳 รับชำระเงิน",
    coAmountDue:        "ยอดที่ต้องชำระ",
    coCash:             "เงินสด",
    coScanPay:          "สแกนเพื่อชำระ",
    coCancelBtn:        "ยกเลิก",
    coOkBtn:            "ตกลง",
    coAddItemTitle:     "เพิ่มรายการ",
    coAddItemSub:       "กรอกเอง หรือเลือกจากรายการที่บันทึกไว้",
    coCustomEntry:      "✏️ กรอกรายการเอง",
    coItemName:         "ชื่อรายการ *",
    coUnitPrice:        "ราคา/หน่วย (บาท) *",
    coServiceItems:     "🏷️ รายการสินค้า / บริการ",
    coSearchItem:       "ค้นหารายการ...",
    coNoSavedItems:     "ยังไม่มีรายการที่บันทึกไว้",
    coNoSearchItem:     "ไม่พบรายการที่ค้นหา",
    coAddBtn:           "+ เพิ่ม",
    coReceivedCash:     "รับชำระเงินสด",
    coReceivedQR:       "รับชำระผ่าน QR Code",
    coUndoBtn:          "ย้อนกลับ",
    coAge:              "อายุ :",
    coItemNamePh:       "เช่น น้ำดื่ม",

    // ── ReceiptEditor ──
    reConfirmDeleteHotel:    "ลบโรงแรม",
    reConfirmDeleteCustomer: "ลบลูกค้า",
    reTitle:            "แก้ไขใบเสร็จ",
    reHotelTab:         "ข้อมูลโรงแรม",
    reCustomerTab:      "ข้อมูลลูกค้า",
    reSearchHotel:      "ค้นหาข้อมูลโรงแรม",
    reSearchHotelBtn:   "ค้นหา / จัดการโรงแรม",
    reLogo:             "โลโก้",
    reSignature:        "รูปลายเซ็น",
    reHotelName:        "ชื่อโรงแรม (ไทย) *",
    reHotelNameEn:      "ชื่อโรงแรม (อังกฤษ)",
    reTaxId:            "หมายเลขผู้เสียภาษี",
    reAddress:          "ที่อยู่",
    reSigner:           "ชื่อผู้รับเงิน",
    reReceiptNo:        "เลขที่ใบเสร็จ",
    reReceiptDate:      "วันที่",
    reIncludeVat:       "รวม VAT 7%",
    reNote:             "หมายเหตุ",
    reBankInfo:         "ข้อมูลบัญชีรับชำระเงิน",
    reBankName:         "ชื่อบัญชี",
    reCustomerName:     "ชื่อลูกค้า",
    reCustomerAddr:     "ที่อยู่ลูกค้า",
    reCustomerTax:      "เลขผู้เสียภาษีลูกค้า",
    reItems:            "รายการ",
    reAddItem:          "+ เพิ่มรายการ",
    rePrintOriginal:    "พิมพ์ (สำเนาลูกค้า)",
    rePrintCopy:        "พิมพ์ (สำเนาบริษัท)",
    reHotelList:        "ข้อมูลโรงแรม",
    reHotelListSub:     "เลือกรายการเพื่อกรอกข้อมูลอัตโนมัติ",
    reCreate:           "+ สร้าง",
    reLoading:          "กำลังโหลด...",
    reNoHotel:          "ไม่พบข้อมูลโรงแรม",
    reEditHotel:        "แก้ไข",
    reDeleteHotel:      "ลบ",
    reEditHotelTitle:   "แก้ไขข้อมูลโรงแรม",
    reNewHotelTitle:    "สร้างโรงแรมใหม่",
    reSave:             "บันทึก",
    reSaving:           "กำลังบันทึก...",
    reCancelBtn:        "ยกเลิก",
    reChangeLogo:       "เปลี่ยนโลโก้",
    reUploadLogo:       "อัปโหลดโลโก้",
    reChangeSign:       "เปลี่ยนลายเซ็น",
    reUploadSign:       "อัปโหลดลายเซ็น",
    reCustomerList:     "ลูกค้า",
    reCustomerListSub:  "เลือกรายการเพื่อกรอกข้อมูลอัตโนมัติ",
    reEditCustomer:     "แก้ไขลูกค้า",
    reNewCustomer:      "สร้างลูกค้าใหม่",
    reCustomerNameLbl:  "ชื่อลูกค้า *",
    reCustomerAddrLbl:  "ที่อยู่",
    reBranchType:       "ประเภทสำนักงาน",
    reHeadOffice:       "สำนักงานใหญ่",
    reBranch:           "สาขา",
    reBranchNo:         "เลขที่สาขา",
    reBranchNoPh:       "เช่น 00001",
    reSelectBooking:    "เลือกจากการจอง",
    reSelectBookingSub: "เลือกรายการเพื่อเพิ่มในใบเสร็จ",
    reManualEntry:      "กรอกเอง",
    reManualEntrySub:   "เพิ่มรายการที่ไม่อยู่ในระบบ",
    reManualForm:       "✏️ กรอกรายการเอง",
    reItemName:         "ชื่อรายการ *",
    reItemQty:          "จำนวน",
    reItemPrice:        "ราคา/หน่วย *",
    reItemDetail:       "รายละเอียดเพิ่มเติม (ไม่บังคับ)",
    reAddBtn:           "+ เพิ่ม",
    reServiceList:      "🏷️ รายการสินค้า / บริการ",
    reSearchItem:       "ค้นหารายการ...",
    reNoSavedItems:     "ยังไม่มีรายการที่บันทึกไว้",
    reNoSearchItem:     "ไม่พบรายการที่ค้นหา",
    reSearchBooking:    "ค้นหาห้อง, อีเมล, รหัสการจอง...",
    reNoMatchBooking:   "ไม่พบการจองที่ตรงกัน",
    reLoadingBooking:   "กำลังโหลดข้อมูล...",
    reNights:           "คืน",
    reAlreadyAdded:     "เพิ่มแล้ว",
    reBack:             "← ย้อนกลับ",
    reToastHotelRequired: "กรุณากรอกชื่อโรงแรม",
    reToastHotelCreated:  "สร้างโรงแรมใหม่แล้ว",
    reToastHotelSaved:    "บันทึกแล้ว",
    reToastCustRequired:  "กรุณากรอกชื่อลูกค้า",
    reToastCustCreated:   "สร้างลูกค้าใหม่แล้ว",
    reToastCustSaved:     "บันทึกแล้ว",
    reToastError:         "เกิดข้อผิดพลาด",
    reSearchHotelPh:      "ค้นหาชื่อโรงแรม, Tax ID...",
    reHotelNamePh:        "ชื่อโรงแรมภาษาไทย",
    reHotelAddrPh:        "ที่อยู่โรงแรม",
    reSignerPh:           "ชื่อผู้รับเงิน",
    reBankInfoPh:         "เช่น ชำระเงินผ่านทางบัญชี กสิกรไทย หมายเลขบัญชี xxx-x-xxxxx-x",
    reBankNamePh:         "เช่น ชื่อบัญชี นายสมชาย ใจดี",
    reSearchCustomerPh:   "ค้นหาชื่อ, Tax ID, ที่อยู่...",
    reCustomerNamePh:     "ชื่อ-นามสกุล / ชื่อบริษัท",
    reCustomerAddrPh:     "ใส่ที่อยู่ของลูกค้า",
    reCustomerNamePh2:    "ใส่ชื่อของลูกค้า",
    reHotelAddrPh2:       "ที่อยู่โรงแรมของคุณ",
    reTaxIdPh:            "หมายเลขผู้เสียภาษีโรงแรมของคุณ",
    reNotePh:             "หมายเหตุเพิ่มเติม",
    reItemNamePh:         "เช่น น้ำดื่ม",
    reItemNamePh2:        "ชื่อรายการ",
    reItemDetailPh:       "รายละเอียด",
    reAddDetailLine:      "+ เพิ่มบรรทัด",
    reRemoveDetailLine:   "ลบบรรทัดนี้",
    reNeedItems:          "กรุณาเพิ่มรายการก่อนพิมพ์",
    reSaveReceiptFail:    "บันทึกใบเสร็จไม่สำเร็จ — ยังไม่ได้พิมพ์ กรุณาลองใหม่",
    reDownloadPdf:        "⬇ ดาวน์โหลด PDF",

    // ── ReceiptArchive (คลังใบเสร็จ) ──
    receiptArchive:  "คลังใบเสร็จ",
    raTitle:         "คลังใบเสร็จ",
    raSub:           "ค้นหา ดู พิมพ์ซ้ำ และดาวน์โหลดใบเสร็จที่เคยออกทั้งหมด",
    raSearch:        "ค้นหา",
    raSearchPh:      "เลขที่ใบเสร็จ หรือชื่อลูกค้า...",
    raDateFrom:      "ตั้งแต่วันที่",
    raDateTo:        "ถึงวันที่",
    raLoad:          "ค้นหา",
    raLoading:       "กำลังโหลด...",
    raLoadFail:      "โหลดข้อมูลไม่สำเร็จ",
    raNoData:        "ไม่พบใบเสร็จ",
    raTotal:         "ทั้งหมด",
    raUnit:          "ใบ",
    raColReceiptNo:  "เลขที่ใบเสร็จ",
    raColDate:       "วันที่",
    raColCustomer:   "ลูกค้า",
    raColTotal:      "ยอดรวม (บาท)",
    raColReprints:   "พิมพ์ซ้ำ (ครั้ง)",
    raColStatus:     "สถานะ",
    raStatusAll:     "ทุกสถานะ",
    raStatusOk:      "ปกติ",
    raStatusVoid:    "ยกเลิกแล้ว",
    raClose:         "ปิด",
    raReprint:       "🖨 พิมพ์ซ้ำ",
    raVoid:          "ยกเลิกใบเสร็จ",
    raVoidReasonPh:  "เหตุผลที่ยกเลิก...",
    raVoidConfirm:   "ยืนยันยกเลิก",
    raVoidCancel:    "ไม่ยกเลิก",
    raVoidedBanner:  "ใบเสร็จนี้ถูกยกเลิกแล้ว",
    raVoidFail:      "ยกเลิกใบเสร็จไม่สำเร็จ",
    raPrev:          "← ก่อนหน้า",
    raNext:          "ถัดไป →",
    raPage:          "หน้า",
    raDownloadExcel: "⬇ ดาวน์โหลด Excel",

    // ── PaymentSettings ──
    psTitle:              "ตั้งค่าบัญชีรับเงิน",
    psSubtitle:           "แก้เบอร์/เลขพร้อมเพย์ / ชื่อบัญชี / ธนาคาร — มีผลกับ QR ทุกหน้าทันที",
    psHotelName:          "ชื่อโรงแรม *",
    psHotelNamePh:        "ชื่อโรงแรมของคุณ",
    psPhone:              "เบอร์พร้อมเพย์ หรือ เลขบัตร ปชช./ผู้เสียภาษี *",
    psPhonePh:            "08X-XXX-XXXX หรือ เลข 13 หลัก",
    psAccountName:        "ชื่อบัญชีพร้อมเพย์",
    psAccountNamePh:      "เช่น EURNGKUM Guest House",
    psBankName:           "ชื่อธนาคาร",
    psBankNamePh:         "เช่น ธนาคารกสิกรไทย",
    psPreview:            "ตัวอย่าง QR",
    psPreviewEmpty:       "กรอกเบอร์/เลขพร้อมเพย์เพื่อดูตัวอย่าง QR",
    psSave:               "บันทึก",
    psSaving:             "กำลังบันทึก...",
    psLoading:            "กำลังโหลด...",
    psToastHotelRequired: "กรุณากรอกชื่อโรงแรม",
    psToastPhoneInvalid:  "ต้องเป็นเบอร์โทร 9-10 หลัก (ขึ้นต้นด้วย 0) หรือเลขบัตร ปชช./ผู้เสียภาษี 13 หลัก",
    psToastSaved:         "บันทึกแล้ว",
    psToastError:         "เกิดข้อผิดพลาด",

    // ── ServiceItems ──
    siConfirmDelete:    "ลบรายการ",
    siTitle:            "รายการสินค้า / บริการ",
    siAddBtn:           "+ เพิ่มรายการ",
    siSearch:           "ค้นหารายการ...",
    siLoading:          "กำลังโหลด...",
    siNoItems:          "ยังไม่มีรายการ กด + เพิ่มรายการ",
    siNoSearch:         "ไม่พบรายการที่ค้นหา",
    siThbUnit:          "บาท",
    siEdit:             "แก้ไข",
    siDelete:           "ลบ",
    siAddTitle:         "เพิ่มรายการใหม่",
    siEditTitle:        "แก้ไขรายการ",
    siNameLabel:        "ชื่อรายการ *",
    siNamePh:           "เช่น น้ำดื่ม, ซักรีด, อาหารเช้า",
    siPriceLabel:       "ราคา (บาท) *",
    siCancelBtn:        "ยกเลิก",
    siSaveBtn:          "บันทึก",
    siSaving:           "กำลังบันทึก...",
    siToastNameRequired: "กรุณากรอกชื่อรายการ",
    siToastPriceInvalid: "ราคาไม่ถูกต้อง",
    siToastAdded:        "เพิ่มรายการแล้ว ✓",
    siToastSaved:        "บันทึกแล้ว ✓",
    siToastError:        "เกิดข้อผิดพลาด",
    siToastDeleted:      "ลบแล้ว ✓",

    // ── SlipVerification ──
    slipActionFail:     "ดำเนินการไม่สำเร็จ กรุณาลองใหม่",
    slipTitle:          "ตรวจสอบสลิปการชำระเงิน",
    slipSearch:         "ค้นหาอีเมล...",
    slipRefresh:        "รีเฟรช",
    slipTabAll:         "ทั้งหมด",
    slipTabPending:     "รอตรวจสอบ",
    slipTabNoSlip:      "รอสลิป (Staff)",
    slipTabApproved:    "อนุมัติแล้ว",
    slipTabRejected:    "ปฏิเสธแล้ว",
    slipColBooker:      "ผู้จอง",
    slipColRoom:        "ห้อง",
    slipColPaid:        "จ่ายมาแล้ว",
    slipColTotal:       "ยอดทั้งหมด",
    slipColPayType:     "วิธีชำระ",
    slipColStatus:      "สถานะ",
    slipColDate:        "วันที่ส่ง",
    slipColAction:      "การดำเนินการ",
    slipColAmount:      "ยอดเงิน",
    slipRoomsSummary:   (r, ty) => `${r} ห้อง · ${ty} ประเภท`,
    slipPaidShort:      (n) => `จ่ายแล้ว ${n}`,
    slipUnpaid:         "ยังไม่ชำระ",
    slipRoomList:       "รายการห้อง",
    slipPrevPage:       "← ก่อนหน้า",
    slipNextPage:       "ถัดไป →",
    slipShowAll:        (n) => `แสดงทั้งหมด (${n})`,
    slipShowPaged:      "แสดงทีละหน้า",
    slipPageOf:         (cur, all) => `หน้า ${cur} จาก ${all}`,
    slipShowingRange:   (from, to, all) => `แสดง ${from}–${to} จาก ${all} รายการ`,
    slipRemaining:      "ยอดคงเหลือ",
    payTypeFull:        "เต็มจำนวน",
    payTypePartial:     "มัดจำ",
    payTypeCash:        "เงินสดหน้าเคาน์เตอร์",
    toastSuccess:       "สำเร็จ",
    toastError:         "เกิดข้อผิดพลาด",
    toastWarn:          "แจ้งเตือน",
    toastInfo:          "แจ้งเตือน",
    slipLoading:        "กำลังโหลด...",
    slipNoItems:        "ไม่มีรายการในหมวดนี้",
    slipNoAccess:       "ไม่มีสิทธิ์เข้าถึง — เฉพาะ admin / staff เท่านั้น",
    slipDetailTitle:    "รายละเอียดสลิป",
    slipStaffBooking:   "🏷️ Staff Booking — รอสลิปจากลูกค้า",
    slipCashBooking:    "💵 จองเงินสด — ยืนยันได้โดยไม่ต้องมีสลิป",
    slipEmail:          "อีเมล",
    slipAmount:         "จำนวนเงิน",
    slipStatus:         "สถานะ",
    slipRoom:           "ห้องพัก",
    slipSentAt:         "วันที่ส่ง",
    slipAdminNote:      "บันทึกจาก admin (ไม่บังคับ)",
    slipApprove:        "✓ อนุมัติ",
    slipReject:         "✗ ปฏิเสธ",
    slipClose:          "ปิด",
    slipCancelled:      "การจองนี้ถูกยกเลิกแล้ว — ไม่สามารถยืนยันสลิปได้",
    slipPendingCancel:  "รอการยืนยันการยกเลิก",
    slipUpload:         "📎 อัปโหลดสลิปจากลูกค้า (Staff)",
    slipClickSelect:    "📷 คลิกเพื่อเลือกรูปสลิป",
    slipChange:         "เปลี่ยน",
    slipSaveSlip:       "✓ บันทึกสลิป",
    slipUploading:      "กำลังอัปโหลด...",
    slipProcessing:     "กำลังดำเนินการ...",
    slipViewSlip:       "ดูสลิป",
    slipAddSlip:        "📎 เพิ่มสลิป",
    slipViewDetail:     "ดูรายละเอียด",
    slipPendingCancelTag: "รอยืนยันการยกเลิก",
    slipCancelledTag:   "ยกเลิกแล้ว",
    slipToastUploadOk:  "อัปโหลดสลิปสำเร็จ — สถานะเปลี่ยนเป็น Pending",
    slipToastUploadFail:"อัปโหลดไม่สำเร็จ",
    slipToastLoadFail:  "โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่",
    slipToastApproved:  "อนุมัติสำเร็จ",
    slipToastRejected:  "ปฏิเสธแล้ว",

    // ── About ──
    aboutTitle:         "หน้าเกี่ยวกับเรา",
    aboutConnecting:    "กำลังเชื่อมต่อ...",
    aboutConnectOk:     "เชื่อมต่อ Backend สำเร็จ! 🚀",
    aboutConnectFail:   "เชื่อมต่อ Backend ไม่ได้ ❌",

    // ── AdminUsers ──
    auRoleChangeFail:   "เปลี่ยนสิทธิ์ไม่สำเร็จ",
    auDeleteFail:       "ลบสมาชิกไม่สำเร็จ",
    auActionError:      "เกิดข้อผิดพลาด",
    auSelectRoleFirst:  "เลือก role ใหม่ก่อน",
    auTitle:            "จัดการสมาชิก",
    auPerson:           "คน",
    auRefresh:          "รีเฟรช",
    auSearch:           "ชื่อ, อีเมล, เบอร์...",
    auAll:              "ทั้งหมด",
    auStaff:            "พนักงาน",
    auCustomer:         "ลูกค้า",
    auLoadFail:         "โหลดข้อมูลไม่สำเร็จ",
    auRetry:            "ลองใหม่",
    auNoMembers:        "ไม่พบสมาชิกที่ตรงกับเงื่อนไข",
    auClearSearch:      "ล้างการค้นหา",
    auJoined:           "เข้าร่วม",
    auSave:             "บันทึก",
    auDelete:           "ลบ",
    auCancel:           "ยกเลิก",
    auConfirmRole:      "ยืนยันการเปลี่ยนสิทธิ์",
    auConfirmDelete:    "ยืนยันการลบสมาชิก",
    auConfirmRoleDesc:  "เปลี่ยนสิทธิ์ของ",
    auFrom:             "จาก",
    auTo:               "เป็น",
    auConfirmQ:         "ใช่หรือไม่?",
    auDeleteDesc:       "ลบ",
    auDeleteWarn:       "การกระทำนี้ไม่สามารถย้อนกลับได้",
    auSaving:           "กำลังบันทึก…",
    auDeleting:         "กำลังลบ…",
    auConfirm:          "ยืนยัน",
    auDeleteBtn:        "ลบสมาชิก",
    auResultCount:      "ผลลัพธ์",
    auItems:            "รายการ",

    // ── AdminCalendar locale ──
    calMonthsTH:     ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],
    calDowTH:        ["อา","จ","อ","พ","พฤ","ศ","ส"],
    calUnknownType:  "ไม่ระบุ",

    // ── AdminDashboard locale ──
    dbMonths: ["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],
    dbDays:     ["อา","จ","อ","พ","พฤ","ศ","ส"],
    dbDaysFull: ["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสบดี","ศุกร์","เสาร์"],
    dbOther:  "อื่นๆ",

    // ── SlipVerification ──
    slipImgAlt: "สลิป",
  },

  en: {
    // ── Navbar ──
    booking:        "Booking",
    status:         "Status",
    profile:        "Profile",
    logout:         "Logout",
    login:          "Login",
    dashboard:      "Dashboard",
    manageRooms:    "Manage Rooms",
    manageMembers:  "Members",
    editReceipt:    "Edit Receipt",
    editItems:      "Edit Items",
    editPaymentSettings: "Payment Account Settings",
    report:         "Report",
    roomBooking:    "Book Room",
    roomManage:     "Manage Rooms",
    roomDetail:     "Room Details",
    cancelReq:      "Cancel Requests",
    checkIn:        "Check In",
    checkOut:       "Check Out",
    verifySlip:     "Verify Slip",

    // ── Rooms page ──
    checkInLabel:   "Check In",
    nightsLabel:    "Nights",
    nightsUnit:     "night(s)",
    checkoutLabel:  "Check Out",
    guestsLabel:    "Guests",
    adults:         "Adults",
    adultsAge:      "Age 18+",
    rooms:          "Rooms",
    roomsCount:     "Number of rooms",
    confirm:        "Confirm",
    filterLabel:    "Filter",
    filterClear:    "Clear filter",
    roomType:       "Room Type",
    roomRate:       "Room Rate",
    sortByPrice:    "Sort by price",
    sortDefault:    "Default",
    sortAsc:        "Low → High ↑",
    sortDesc:       "High → Low ↓",
    allTypes:       "All",
    resultInfo:     (n, a, ni) => `Found ${n} room(s) · ${a} guest(s) · ${ni} night(s)`,
    noRooms:        "No rooms match your criteria",
    breakfast:      "Breakfast included",
    capacity:       (a, c) => `Up to ${a} adult(s)${c > 0 ? ` + ${c} child(ren)` : ""}`,
    perNight:       "THB / night",
    totalNights:    (n, p) => `Total ${n} night(s): ${p} THB`,
    viewDetail:     "View details →",
    priceUp:        "Price ↑",
    priceDown:      "Price ↓",

    // ── Room cart ──
    addToCart:      "Add to cart",
    soldOut:        "Sold out",
    roomsLeft:      (n) => `${n} left`,
    cartTitle:      "Your rooms",
    cartCount:      (r, ty) => `${r} room(s) · ${ty} type(s)`,
    cartEmpty:      "No rooms selected",
    cartClear:      "Clear",
    cartView:       "View list",
    cartOpen:       "Open cart",
    cartClose:      "Close",
    cartHide:       "Hide list",
    cartCheckout:   (n) => `Book ${n} room(s) →`,
    cartTotal:      "Total",
    cartRemove:     "Remove",
    cartAdded:      (name) => `${name} added to cart`,
    cartTrimmed:    "Some quantities were adjusted to match availability for the new dates.",
    cartMaxReached: (n) => `Up to ${n} rooms per booking`,
    cartSoldOutMsg: "This room type is sold out for the selected dates.",
    availError:     "Could not check availability. Please try again.",
    rdAddToCart:    "Add to cart",
    grandTotal:     "Grand total",
    payItemLine:    (name, qty) => `${name} × ${qty} room(s)`,
    payRoomsTitle:  "Rooms",
    payMultiHeading:(rooms, types) => `${rooms} room(s) · ${types} type(s)`,
    payQtyChip:     (n) => `× ${n}`,

    // ── Status page ──
    allBookings:    "All Bookings",
    roomNoLabel:    "Room No.",
    myBookings:     "Booking Status",
    items:          "items",
    searchStaff:    "Search guest, room, email...",
    searchUser:     "Search room type, room number...",
    loading:        "Loading...",
    noBookings:     "No bookings yet",
    noCategoryItems:"No items in this category",
    noSearchResult: (q) => `No results for "${q}"`,
    bookingDate:    "Booked",
    checkInDate:    "Check-in",
    checkOutDate:   "Check-out",
    nightsCount:    "Nights",
    total:          "Total",
    details:        "Details",
    allStatus:      "All",
    dateFilterBy:   "Booked date :",
    dateAll:        "All",
    dateDay:        "By day",
    dateMonth:      "By month",
    dateRange:      "Date range",
    dateTo:         "to",
    noPeriodItems:  "No bookings in the selected period",

    // ── Booking detail ──
    bookingDetail:  "Booking Detail",
    back:           "← Back",
    cancelBooking:  "Cancel Booking",
    statusLabel:    "Status",

    // ── Status labels ──
    Pending:        "Pending",
    Approved:       "Approved",
    Confirmed:      "Confirmed",
    CheckedIn:      "Checked In",
    CheckedOut:     "Checked Out",
    Cancelled:      "Cancelled",
    PendingCancel:  "Pending Cancel",

    // ── Login ──
    loginTitle:     "Sign In",
    emailLabel:     "Email",
    passwordLabel:  "Password",
    forgotPassword: "Forgot password?",
    noAccount:      "Don't have an account?",
    registerLink:   "Sign up",
    loginWith:      "Or sign in with",

    // ── Register ──
    registerTitle:  "Create Account",
    firstnameLabel: "First Name",
    lastnameLabel:  "Last Name",
    phoneLabel:     "Phone Number",
    confirmPass:    "Confirm Password",
    haveAccount:    "Already have an account?",
    registerBtn:    "Sign Up",
    agreeTerms:     "I agree to the",
    termsLink:      "Terms of Service",
    and:            "and",
    privacyLink:    "Privacy Policy",

    // ── Profile ──
    profileTitle:   "My Profile",
    editProfile:    "Edit Profile",
    saveProfile:    "Save",
    cancelEdit:     "Cancel",
    bookingHistory: "Booking History",

    // ── Booking detail ──
    roomDefault:    "Room",
    breakfastIncl:  "Breakfast included",
    noPets:         "No pets allowed",
    persons:        "guests",
    beds:           "beds",
    bookingSection: "Booking Details",
    bookedAt:       "Booked",
    checkInDate2:   "Check-in Date",
    checkOutDate2:  "Check-out Date",
    nightsCount2:   "Nights",
    totalAmount:    "Total",
    paidAmountLbl:  "Paid",
    remainingLbl:   "Balance due",
    statusColon:    "Status",
    cancelBtn:      "Cancel Booking",
    pendingPayment: "Awaiting Payment",
    pendingPaySub:  "Guest hasn't paid yet — waiting for slip or cash payment",
    checkSlip:      "Verify Slip →",
    paidReadyIn:    "Payment Confirmed — Ready to Check In",
    unpaidReadyIn:  "Not Paid Yet — Room is Reserved",
    partialReadyIn: "Partially Paid — Balance Outstanding",
    collectAtDesk:  "Collect payment at the counter on check-in",
    confirmedReadyIn:"Booking Confirmed — Ready to Check In",
    stayingReadyOut:"Guest is staying — Ready to Check Out",
    checkoutDone:   "Checked Out",
    stayComplete:   "Stay completed",
    pendingCancelTitle: "Cancellation Pending Review",
    pendingCancelSub:   "Guest requested cancellation — awaiting admin review",
    reviewCancel:   "Review →",
    checkInBtn:     "Check In",
    checkOutBtn:    "Check Out",

    // ── Login ──
    signIn:         "Sign In",
    continueGoogle: "Continue with Google",
    orEmail:        "or sign in with email",
    signingIn:      "Signing in...",
    logIn:          "Log in",
    forgotPass:     "Forgot your password?",
    createAccount:  "Create an account",

    // ── Register ──
    createAccTitle: "Create Account",
    sendingOtp:     "Sending OTP...",
    createAccBtn:   "Create Account",
    alreadyHaveAcc: "Already have an account? Login",
    agreeToThe:     "Agree to the",
    termsOfUse:     "Terms of Use",
    andWord:        "and",
    privacyPol:     "Privacy Policy",
    passMatch:      "✓ Passwords match",
    passNoMatch:    "✗ Passwords do not match",
    pwdMin:         "At least 8 characters",
    pwdUpper:       "1 uppercase letter",
    pwdLower:       "1 lowercase letter",
    pwdNumber:      "1 number",
    pwdSpecial:     "1 special character",

    // ── ForgotPassword / ResetPassword / VerifyOTP ──
    forgotPwdTitle: "Forgot Password",
    sendOtp:        "Send OTP",
    resetPwdTitle:  "Reset Password",
    newPassword:    "New Password",
    saving:         "Saving...",
    savePassword:   "Save Password",
    verifyOtpTitle: "Verify OTP",
    enterOtp:       "Enter OTP",
    verifying:      "Verifying...",
    verifyBtn:      "Verify",

    // ── RoomDetail ──
    rdLoadFail:     "Failed to load room",
    rdServerError:  "Server may be unresponsive, or this room has been removed.",
    retry:          "Retry",
    backToRooms:    "Back to rooms",
    highlight:      "Highlight",
    breakfastIncluded: "Breakfast Included",
    petsAllowed:    "Pets Allowed",
    noPetsAllowed:  "No Pets Allowed",
    bedSpec:        (size, n) => `${size} ft × ${n} bed${n > 1 ? "s" : ""}`,
    facilities:     "Facilities & Amenities",
    facWaterHeater: "Water Heater",
    facTelevision:  "Television",
    facAirCon:      "Air Conditioner",
    facWifi:        "Wi-Fi",
    facWasher:      "Washer",
    facFridge:      "Refrigerator",
    reviewTitle:    "Review",
    reviewScore:    "Very Good",
    rdCheckIn:      "CHECK IN",
    rdCheckOut:     "CHECK OUT",
    rdPerson:       "PERSON",
    rdBookBtn:      "Book Now →",

    // ── Profile page ──
    profileUser:    "User Profile",
    changePhoto:    "Change photo",
    save:           "Save",
    editBtn:        "Edit",
    fullName:       "Full Name",
    addressLabel:   "Address",
    birthdayLabel:  "Birthday",
    genderLabel:    "Gender",
    countryLabel:   "Country",
    phoneNumLabel:  "Phone Number",
    optionalTag:    "optional",
    accountSecurity:"Account Security",
    mobileLabel:    "Mobile Number",
    changePwdEmail: "Change password via email",
    changeBtn:      "Change",
    lastLogin:      "Last Login",
    bookingHistoryTitle: "Booking History",
    noHistory:      "No booking history yet",
    paidFull:       "✓ Paid",
    colRoom:        "Room",
    colType:        "Type",
    colCheckIn:     "Check-in",
    colCheckOut:    "Check-out",
    colTotal:       "Total",
    colPaid:        "Paid",
    colRemaining:   "Remaining",
    colStatus:      "Status",
    male:           "Male",
    female:         "Female",
    notSpecified:   "Not specified",
    defaultUser:    "Username",

    // ── Profileinfo ──
    profileInfoTitle: "Profile Information",
    genderSelect:   "Select gender",
    phoneThaiLabel: "Phone number (Thailand)",
    idCardLabel:    "ID Card / Passport",
    saveBtn:        "Save",
    addressPh:      "Your address",
    countryPh:      "Your country",
    firstPh:        "First name",
    lastPh:         "Last name",

    // ── Home ──
    heroDesc:       "Welcome to EURNGKUM Guest House, Nan Province — affordable, clean, and safe rooms at friendly prices.",
    bookRoomBtn:    "Book a Room",
    roomPriceTitle: "Room Rates",
    amenitiesNote:  "✦ 35 rooms ✦ Air conditioning ✦ TV ✦ Refrigerator ✦ Water heater ✦ Parking",
    attractionsTitle:"Attractions",
    attractionsDesc: "Staying at EURNGKUM Guest House makes travel more convenient, as it is located close to major attractions in Nan Province.",
    seeInfo:        "View info ›",
    contactTitle:   "Contact Us",
    contactHotel:   "EURNGKUM Guest House",
    contactAddress: "Address",
    contactPhone:   "Phone",
    contactMobile:  "Mobile",
    contactWebsite: "Website",
    openInMaps:     "Open in Google Maps",
    roomSingle:     "Single Bed",
    roomDouble:     "Double Bed",
    roomSpecial:    "Special Room",
    "ห้องพักเตียงเดี่ยว": "Single Room",
    "ห้องพักเตียงคู่":    "Double Room",
    "ห้องพักสามเตียง":    "Triple Room",
    "ห้องพักเตียงใหญ่ 1 เล็ก 1": "Family Room (1 Double + 1 Single)",
    "ห้องพักสี่เตียง":    "Quad Room",
    guestsPer:      "guests/room",
    perNightUnit:   "/night",

    // ── OAuthConsent ──
    oauthLoginWith: "Signed in with",
    oauthTitle:     "Confirm Terms of Service",
    oauthSubtitle:  "Before you start using",
    oauthSubtitle2: "Please read and accept the terms below.",
    oauthReadBtn:   "📄 Read Terms of Service and Privacy Policy",
    oauthScrollHint:"Please open and scroll to the bottom before accepting.",
    oauthReadAll:   "✓ Read completely",
    oauthScrollFirst:"Please scroll to the bottom",
    oauthAgreeText: "I have read and agree to the Terms of Service and Privacy Policy.",
    acceptBtn:      "Accept",
    processing:     "Processing...",
    acceptAndStart: "✓ Accept and Continue",
    cancelAndLeave: "Cancel — Don't use",
    oauthModalTitle:"Terms of Service and Privacy Policy",

    // ── Payment ──
    scanToTransfer: "Scan to transfer",
    accountNameLabel:"Account name",
    bankLabel:      "Bank",
    promptPayLabel: "PromptPay number",
    copied:         "✓ Copied",
    copyBtn:        "Copy",
    amountLabel:    "Amount",
    depositTag:     "Deposit",
    uploadSlipAfter:"After transferring, please upload the slip below.",
    bookingSuccessTitle:"Booking Successful!",
    waitingSlipVerify:"Waiting for admin to verify your slip",
    popupCheckIn:   "Check-in",
    popupCheckOut:  "Check-out",
    popupNights:    "Nights",
    popupRooms:     "Rooms",
    popupRoomNos:   "Room numbers",
    roomsUnit:      "room(s)",
    sumLineRooms:   (price, nights, rooms) => `${price} THB × ${nights} night(s) × ${rooms} room(s)`,
    sumLineOne:     (price, nights) => `${price} THB × ${nights} night(s)`,
    popupStatus:    "Status",
    pendingReview:  "Pending Review",
    paidPopup:      "Paid",
    payAtCounter:   "Pay at counter",
    partialTag:     "partial",
    amountDue:      "Amount due",
    remainingBalance:"Balance",
    adminVerify24h: "Admin team will verify your slip and confirm booking within 24 hours.",
    cashApprovedSub:  "Booking confirmed — pay at the counter",
    cashApprovedBadge:"Approved",
    cashApprovedNote: "Your booking is confirmed. Please pay at the counter on your check-in day.",
    cashPendingSub:   "Booking request sent — awaiting staff confirmation",
    cashPendingNote:  "Staff will confirm your booking within 24 hours. Then pay cash at the counter on your check-in day.",
    newAccountNote: "Account created. Please check your email for your password.",
    acknowledge:    "Got it",
    roomNotFound:   "Room not found",
    guestInfoTitle: "Guest Information",
    firstNameLabel: "First Name",
    lastNameLabel:  "Last Name",
    customerFirstPh:"Customer first name",
    customerLastPh: "Customer last name",
    customerEmailPh:"Customer email",
    customerPhonePh:"Customer phone",
    paymentMethodTitle:"Payment Method",
    payFull:        "Pay in full",
    payPartial:     "Pay partial (50% deposit)",
    payCash:        "Pay cash",
    payPartialNote: "The deposit is fixed at 50% of the total. Pay the rest at the counter on your check-in day.",
    cashNote:       "No slip upload needed — staff will confirm your booking, then pay at the counter on your check-in day.",
    paymentChannelTitle:"Payment Channel",
    uploadSlipTitle:"Upload Slip",
    clickToSelectSlip:"Click to select slip image",
    slipFileHint:   "PNG, JPG max 5MB",
    changeSlip:     "Change slip",
    payNow:         "Pay now",
    amountAtCounter:"Amount to pay at counter",
    remainingDue:   "Remaining balance",
    submitting:     "Submitting...",
    nightsUnit2:    "night(s)",

    // ── AdminCalendar ──
    calManageRooms:     "Manage Rooms",
    calRoomColHead:     "Room",
    calDayColHead:      "Day",
    calRoomType:        "Room Type",
    calRoomStatus:      "Room Status",
    calAllRooms:        "All",
    calBookedRooms:     "Booked Rooms",
    calOccupiedRooms:   "Occupied Rooms",
    calMaintRooms:      "Under Maintenance",
    calMonth:           "Month",
    calYear:            "Year",
    calNoRooms:         "🏨 No room data yet",
    calEditPeriod:      "Edit Period",
    calManagePeriod:    "Manage Period",
    calType:            "Type",
    calStartDate:       "Start Date",
    calEndDate:         "End Date",
    calColor:           "Color",
    calReason:          "Reason",
    calReasonRequired:  "Please specify a reason",
    calCancel:          "Cancel",
    calSaving:          "Saving...",
    calSaveEdit:        "Save Edit",
    calSave:            "Save",
    calDelete:          "🗑️ Delete",
    calCheckNewIn:      "New Check-in",
    calCheckNewOut:     "New Check-out",
    calNights:          "Nights",
    calStatus:          "Status",
    calNewTotal:        "New Total",
    calOldTotal:        "Old",
    calChangeDateQ:     "Change Booking Date?",
    calChangeRoomDateQ: "Change Room / Date?",
    calGuestName:       "Guest",
    calStatusLabel:     "Status",
    calCheckIn:         "Check-in",
    calCheckOut:        "Check-out",
    calOccupied:        "Room unavailable",
    calMaintenance:     "Under maintenance",
    calOther:           "Other",
    calChooseColor:     "Choose color",
    calLabelBooked:     "Reserved",
    calLabelCheckedIn:  "Checked In",
    calLabelCancelled:  "Cancelled",
    calNightSuffix:     "night(s)",
    calConfirm:         "Confirm",
    calReasonPh:        "Enter reason...",
    calCheckinCount:    "Check-ins today",
    calAvailCount:      "Available rooms",
    calBookedCount:     "Booked rooms",
    calToastSaved:      "Changes saved ✓",
    calToastSaveFail:   "Save failed",
    calToastError:      "An error occurred",
    calToastBlockSaved: "Period saved ✓",
    calToastBlockEdited:"Period updated ✓",
    calToastDeleted:    "Period deleted ✓",
    calToastDeleteFail: "Delete failed",
    calToastConnErr:    "Cannot connect to server",
    calTabBooking:      "Book Room",
    calTabBlock:        "Block Room",
    calBkGuestName:     "Guest name",
    calBkGuestNamePh:   "e.g. John Smith",
    calBkPhone:         "Phone",
    calBkPhonePh:       "08X-XXX-XXXX",
    calBkPayment:       "Payment",
    calBkPaidFull:      "Paid in full",
    calBkPaidPartial:   "Partial",
    calBkPaidNone:      "Not paid",
    calBkPartialAmt:    "Amount paid (THB)",
    calBkRemain:        "Remaining",
    calBkErrPartial:    "Amount paid must be more than 0 and not exceed the total",
    calBkCheckInNow:    "Check in now",
    calBkCheckInHint:   "Takes you to the check-in form · nothing is saved until check-in is confirmed",
    calBkTotal:         "Total",
    calBkSubmit:        "Confirm booking",
    calBkSubmitting:    "Booking...",
    calBkErrDate:       "Check-out must be at least 1 night after check-in",
    calBkErrOverlap:    "This room is not available for the selected dates",
    calBkErrNoRoom:     "Please select at least one room",
    calBkErrNamePerRoom:"Please enter a guest name for every room",
    calBkSameGuest:     "Same guest for all rooms",
    calBkSameGuestOn:   "One guest booking several rooms - enter the name once",
    calBkSameGuestOff:  "Enter a guest name per room in the list above",
    calDragHint:        "Click an empty cell and drag to pick the date range",
    calRoomsUnit:       "rooms",
    calBkRoomList:      "Selected rooms",
    calBkRoomBusy:      "Not available",
    calMultiStart:      "Book multiple rooms",
    calMultiExit:       "Exit selection",
    calMultiSelectAll:  "Select all available",
    calMultiClear:      "Clear selection",
    calMultiSetAll:     "Set dates for all",
    calMultiMixedDates: "⚡ Rooms have different dates",
    calMultiConflict:   (rooms) => `⛔ Room ${rooms} overlaps another booking`,
    calMultiPicked:     (n) => `${n} room(s) selected`,
    calMultiBook:       (n) => `Book ${n} room(s) →`,
    calBkToastGroupOk:  (n, rooms) => `${n} rooms booked ✓ (${rooms})`,
    calBkErrName:       "Please enter the guest name",
    calBkPhoneOpt:      "optional",
    calCancelBkBtn:     "Cancel booking",
    calNextSlip:        "Verify slip →",
    calNextCheckIn:     "Go to check-in →",
    calNextCheckOut:    "Go to check-out →",
    calCancelBkConfirm: "Cancel this booking? The room is freed immediately and this cannot be undone.",
    calCancelBkReasonPh:"Reason (optional)",
    calCancelBkYes:     "Confirm cancellation",
    calCancelBkBack:    "Back",
    calCancelBkBusy:    "Cancelling...",
    calCancelBkOk:      "Booking cancelled",
    calCancelBkLocked:  "This booking can't be cancelled (already checked out or cancelled)",
    calBkToastOk:       "Room {room} booked ✓",
    calZoomOut:         "Zoom out",
    calZoomIn:          "Zoom in",
    calBackToMonth:     "Back to month",
    calNightsUnit:      "nights",
    calDue:             "Due",
    calPaidFull:        "Paid",
    calWalkIn:          "Walk-in",
    calPrevDay:         "Previous day",
    calNextDay:         "Next day",
    calDayViewHint:     "Click to view this day",
    calTypeSingle:      "Single",
    calTypeDouble:      "Double",
    calTypeFamily:      "Family",
    calTypeTriple:      "Triple",
    calTypeQuad:        "Quad",

    // ── AdminDashboard ──
    dbRevenueAccYear:   "Total • Year",
    dbBookings:         "Bookings",
    dbStatusPending:    "Pending",
    dbStatusApproved:   "Approved",
    dbStatusConfirmed:  "Confirmed",
    dbStatusCheckedIn:  "Checked In",
    dbStatusCheckedOut: "Checked Out",
    dbStatusCancelled:  "Cancelled",
    dbNewBooking:       "New Booking —",
    dbPayment:          "Payment",
    dbMinAgo:           "min ago",
    dbHrsAgo:           "hrs ago",
    dbYesterday:        "Yesterday",
    dbDashboard:        "Dashboard",
    dbRevenueYear:      "Total Revenue (Year)",
    dbRevenueMonth:     "Revenue (This Month)",
    dbRevenueDay:       "Revenue (Today)",
    dbTotalGuests:      "Total Guests",
    dbRefresh:          "⟳ Refresh",
    dbMonthlyRevenue:   "Monthly Revenue",
    dbThisYear:         "This Year",
    dbLastYear:         "Last Year",
    dbCheckins:         "Check-ins",
    dbRoomUsage:        "Room Usage",
    dbNoBookings:       "No bookings yet",
    dbNoGuests:         "No customers have booked",
    dbRecentBookings:   "Recent Bookings",
    dbNotifications:    "System Notifications",
    dbNoNotifs:         "No notifications",
    dbBookingStatus:    "Booking Status",
    dbMonthly:          "Monthly",
    dbWeekly:           "Weekly",

    // ── GuestRegistry ──
    grTitle:            "Guest registry",
    grSub:              "Guest details, stay history and customer-segment analytics",
    grTabRegistry:      "Registry",
    grTabAnalytics:     "Analytics",
    grSearch:           "Search",
    grSearchPh:         "Name / ID / phone / company / licence plate",
    grType:             "Guest type",
    grTypeAll:          "All types",
    grFrom:             "Stayed from",
    grTo:               "To",
    grLoad:             "Search",
    grLoading:          "Loading...",
    grExport:           "⬇️ Download Excel",
    grExporting:        "Building file...",
    grExportOk:         "File downloaded",
    grExportFail:       "Could not build the file",
    grQuickRange:       "Range:",
    grRangeAll:         "All time",
    grRange12m:         "±1 year",
    grRangeThisY:       "This year",
    grRangeLastY:       "Last year",
    grFilterNote:       "Leave the dates empty to see everything · the range filters on check-in date and the Analytics tab uses the same range.",
    grLoadFail:         "Failed to load data",
    grSaveFail:         "Could not save",
    grSaved:            "Saved",
    grEmpty:            "No guests in the registry yet",
    grNoData:           "No data for the selected period",
    grStatGuests:       "Guests",
    grStatStays:        "Stays",
    grStatDue:          "Total outstanding",
    grStatRevenue:      "Total revenue (THB)",
    grStatAvgNights:    "Avg nights / stay",
    grStatAvgSpend:     "Avg spend / stay",
    grStatNewGuest:     "New / returning",
    grStatCar:          "With car / without",
    grStatChannel:      "Walk-in / online",
    grColName:          "Full name",
    grColType:          "Type",
    grColIdCard:        "ID / passport",
    grColPhone:         "Phone",
    grColCompany:       "Company",
    grColCar:           "Licence plate",
    grColStays:         "Stays",
    grColLastStay:      "Last stay",
    grColTotal:         "Lifetime total",
    grColDue:           "Outstanding",
    grColNights:        "Nights",
    grColNote:          "Note",
    grEdit:             "Edit",
    grSave:             "Save",
    grSaving:           "Saving...",
    grCancel:           "Cancel",
    grSecIdentity:      "Personal details",
    grSecNote:          "Internal note",
    grSecHistory:       "Full stay history",
    grDetailStays:      (n) => `${n} stay${n === 1 ? "" : "s"} so far`,
    grDetailPaid:       "Total paid",
    grDetailFirst:      "First stay",
    grChartMix:         "Guest type mix",
    grChartMixSub:      "Corporate guests versus tourists and other segments",
    grChartRevenue:     "Revenue by guest type",
    grChartRevenueSub:  "Which segment brings in the most",
    grChartMonthly:     "Monthly stays by guest type",
    grChartMonthlySub:  "Shows when tourists peak and how many corporate guests stay each month",
    grChartCompanies:   "Top 10 companies by stays",
    grChartCompaniesSub:"Key corporate accounts",
    grChartProvince:    "Where guests come from (plate province)",
    grChartProvinceSub: "Useful for choosing marketing areas",
    grProvinceCaveat:   "Note: rental and company cars may be registered in a different province from where the guest lives. Use for overall trends, not for individual conclusions.",
    grUnitStays:        "stays",
    grUnitBaht:         "THB",

    // ── AdminReport ──
    rptLoadFail:        "Failed to load data",
    rptTitle:           "Generate Stay Report",
    rptSub:             "Data from checked-out bookings",
    rptSelectMonth:     "📅 Select Month",
    rptNMonths:         "🔢 Number of Months",
    rptDateRange:       "🗓️ Date Range",
    rptMonth:           "Month",
    rptYear:            "Year (B.E.)",
    rptNMonthsBack:     "Months back",
    rptDateFrom:        "From date",
    rptDateTo:          "To date",
    rptSearchGuest:     "🔍 Filter by guest name / email",
    rptSearchPh:        "Search guests...",
    rptLoad:            "Load Data",
    rptLoading:         "⏳ Loading...",
    rptTotal:           "Total",
    rptItems:           "records",
    rptRevenue:         "Total Revenue",
    rptDownload:        "⬇️ Download Excel",
    rptNoData:          "No data in selected period",
    rptColNum:          "#",
    rptColGuest:        "Guest Name",
    rptColEmail:        "Email",
    rptColRoom:         "Room",
    rptColType:         "Type",
    rptColCheckIn:      "Check-in",
    rptColCheckOut:     "Check-out",
    rptColNights:       "Nights",
    rptColTotal:        "Total Price",
    rptColPaid:         "Paid",
    rptDaily:           "📆 Daily Report (All Rooms)",
    rptDailyDate:       "Select date",
    rptColPhone:        "Phone",
    rptColRemain:       "Remaining",
    rptColRoomNo:       "Room No.",
    rptColRoomStatus:   "Room Status",
    rptVacant:          "Vacant",
    rptOccupied:        "Occupied",
    rptRoomsTotal:      "Total Rooms",
    rptRoomsOccupied:   "Occupied Rooms",
    rptRoomsVacant:     "Vacant Rooms",
    rptOutstanding:     "Outstanding",

    // ── AdminRooms ──
    arRoomNameThPh:     "e.g. Double Bed Room",
    arRoomDescPh:       "Describe amenities, view, room size, etc.",
    arDefaultNightsPh:  "e.g. 2 nights",
    arTitle:            "Manage Rooms",
    arRooms:            "rooms",
    arRefresh:          "Refresh",
    arSearch:           "Search rooms...",
    arAddRoom:          "Add Room",
    arAll:              "All",
    arEditRoom:         "Edit Room",
    arAddNewRoom:       "Add New Room",
    arBasicInfo:        "Basic Info",
    arRoomNameTh:       "Room Name (Thai)",
    arRoomType:         "Room Type",
    arRoomNameEn:       "Room Name (English)",
    arRoomNameEnNote:   "— shown when user switches to English",
    arRoomDesc:         "Room Description",
    arCapacity:         "Capacity",
    arMaxAdults:        "Max Adults",
    arMaxChildren:      "Max Children",
    arBeds:             "Beds in room",
    arBedsNote:         "— bed width (feet) and how many; multiple sizes allowed",
    arBedFt:            "ft",
    arBedUnit:          "beds",
    arAddBed:           "+ Add bed",
    arBedsEmpty:        "No beds specified — the room detail page will hide the bed line",
    arBedsPreview:      "Will display as:",
    arDefaultNights:    "Default Nights",
    arUnits:            "Room Units",
    arUnitPrefix:       "Prefix (A, B, C…)",
    arUnitCount:        "Number of Rooms",
    arRoomNumbers:      "🏨 Room numbers will be:",
    arManualUnitsNote:  "🔒 Room numbers for this type are set manually from the real floor plan (e.g. 1, V2, 301) — cannot be edited here",
    arManualEditHint:   "Set room numbers manually to match the real floor plan (e.g. 1, V2, 301) — add, edit, or remove each room",
    arUnitNumber:       "Room number",
    arUnitNumberPh:     "e.g. 101, V2, 301",
    arAddUnit:          "+ Add room",
    arUnitsShow:        "Show room numbers",
    arUnitsHide:        "Hide room numbers",
    arUnitModeAuto:     "Auto-generate",
    arUnitModeManual:   "Set manually",
    arUnitNeedOne:      "Please add at least one room number",
    arUnitBooked:       "Booked",
    arUnitLoadFail:     "Failed to load room numbers",
    arPricing:          "Pricing",
    arRoomPrice:        "Room Price (THB)",
    arFilterPrice:      "Price for filter",
    arOptions:          "Additional Options",
    arBreakfast:        "Breakfast included",
    arPhoto:            "Room Photo (main)",
    arPhotoExtra:       "Additional Photos",
    arPhotoExtraNote:   "Select multiple (up to 12)",
    arPhotoRemove:      "Remove this photo",
    arSaveEdit:         "Save Edit",
    arAddRoomBtn:       "Add Room",
    arCancelBtn:        "Cancel",
    arDeleteConfirm:    "Confirm Delete Room",
    arDeleteDesc:       "Remove room",
    arDeleteWarn:       "This action cannot be undone",
    arDeleteBtn:        "Delete Room",
    arDeleting:         "Deleting…",
    arToastLoadFail:    "Failed to load data",
    arToastEditOk:      "Room updated successfully",
    arToastAddOk:       "Room added successfully",
    arToastSaveFail:    "Failed to save data",
    arToastDeleteOk:    "Room deleted successfully",
    arNoRooms:          "No rooms found",
    arNoSearch:         "No rooms match search",
    arEdit:             "Edit",
    arDelete:           "Delete",
    arBreakfastBadge:   "🍳 Breakfast",
    arAdults:           "👤 Adults",
    arPerson:           "person(s)",
    arChildren:         "👦 Children",
    arPerNight:         "/ night",
    arUnitsLabel:       "units",

    // ── AdminPayments ──
    pymTitle:           "Payment Verification",
    pymRoom:            "Room",
    pymEmail:           "Email",
    pymAmount:          "Amount",
    pymStatus:          "Status",
    pymApprove:         "Approve",
    pymReject:          "Reject",

    // ── Admincancellationpage ──
    cancLoadFail:       "Failed to load data",
    cancActionFail:     "Action failed",
    cancTitle:          "Cancellation Requests",
    cancSub:            "Review and respond to customer cancellation requests",
    cancPending:        "Pending",
    cancApproved:       "Approved",
    cancRejected:       "Rejected",
    cancLoading:        "Loading...",
    cancNoItems:        "No requests with this status",
    cancColGuest:       "Guest",
    cancColRoom:        "Room",
    cancColCheckIn:     "Check-in",
    cancColTotal:       "Total",
    cancColRequested:   "Requested",
    cancColStatus:      "Status",
    cancReview:         "Review",
    cancViewDetail:     "View Detail",
    cancModalTitle:     "Review Cancellation Request",
    cancBookingInfo:    "Booking Information",
    cancGuest:          "Guest",
    cancRoom:           "Room",
    cancCheckIn:        "Check-in",
    cancCheckOut:       "Check-out",
    cancTotal:          "Total",
    cancReason:         "Customer Reason",
    cancNoReason:       "No reason provided",
    cancRefund:         "Refund Amount (THB)",
    cancNote:           "Note to Customer (optional)",
    cancNotePh:         "e.g. Refund within 3-5 business days...",
    cancCancelBtn:      "Cancel",
    cancRejectBtn:      "Reject",
    cancApproveBtn:     "Approve Cancellation",
    cancProcessing:     "Processing...",
    cancResult:         "Decision",
    cancDecisionStatus: "Status",
    cancRefundAmt:      "Refund Amount",
    cancNoRefund:       "No refund",
    cancActionDate:     "Processed",
    cancNoteLabel:      "Note",
    cancClose:          "Close",
    // ── Admin-initiated cancellation ──
    cancAdminNewBtn:    "Cancel a Booking",
    cancAdminTitle:     "Select a booking to cancel",
    cancAdminSub:       "Only rooms that are booked or checked-in",
    cancAdminNoActive:  "No cancellable bookings right now",
    cancAdminPick:      "Cancel",
    cancAdminConfirmTitle: "Confirm booking cancellation",
    cancAdminReason:    "Cancellation reason",
    cancAdminReasonPh:  "e.g. Customer requested cancellation by phone...",
    cancAdminConfirmBtn:"Confirm Cancellation",
    cancAdminBooked:    "Booked",
    cancAdminCheckedIn: "Checked-in",
    cancAdminSuccess:   "Booking cancelled successfully",

    // ── CheckIn / CheckOut shared ──
    ciUnknownName:      "Unknown",
    ciDefaultRoom:      "Room",

    // ── CheckIn ──
    ciTitle:            "Check In",
    ciBack:             "Back",
    ciIdCard:           "ID Card / Passport Number",
    ciIdCardPh:         "Enter ID card / Passport No.",
    ciReadCard:         "Read ID Card",
    ciReadingCard:      "Reading card...",
    ciReadCardOk:       "ID card read successfully",
    ciReadCardHint:     "Insert the card into the reader, then click to auto-fill",
    ciAgentOffline:     "Cannot reach the card reader — please start the ID Card Agent on this PC",
    ciAgentOnline:      "Card reader ready",
    ciAgentOfflineShort:"Card reader offline",
    ciAgentChecking:    "Checking card reader...",
    ciAgentNoReader:    "No card reader detected — please plug one in",
    ciAgentNoPcsc:      "Card reader service (PC/SC) unavailable",
    ciAgentCardIn:      "Card detected — ready to read",
    ciAgentCheckFail:   "Could not check the card reader",
    ciOcrPick:          "Read data from card photo (photo is not saved)",
    ciOcrReading:       "Reading card photo...",
    ciOcrOk:            (n) => `Card photo read — filled ${n} field(s), please verify`,
    ciOcrDone:          "Photo processed — the image was not saved",
    ciOcrNone:          "Text was read but no card fields matched — please fill in manually",
    ciOcrUnreadable:    "Photo too unclear — fill the frame with the card, even lighting, no glare, then retry",
    ciOcrFail:          "Error reading the photo — please fill in manually",
    ciFieldName:        "Full Name",
    ciFieldAddress:     "Address",
    ciFieldBirthDate:   "Birth Date",
    ciFieldGender:      "Gender",
    ciFieldCountry:     "Country",
    ciFieldNationality: "Nationality",
    ciFieldPhone:       "Phone Number",
    ciFieldExtra:       "Additional Info",
    ciGenderSelect:     "-- Select Gender --",
    ciGenderM:          "Male",
    ciGenderF:          "Female",
    ciGenderOther:      "Other",
    ciGenderNA:         "Not specified",
    ciBookingDetail:    "Booking Details",
    ciRoomFor:          "Room for",
    ciPersons:          "person(s)",
    ciBookedOn:         "Booked on",
    ciCheckIn:          "Check-in",
    ciCheckOut:         "Check-out",
    ciTotalPrice:       "Total Price",
    ciPaid:             "Paid",
    ciBalanceDue:       "Balance Due",
    ciBalance:          "Balance",
    ciPaidFull:         "Fully Paid ✓",
    ciPay:              "Pay",
    ciNoImage:          "No image",
    ciPayTitle:         "💳 Collect Payment",
    ciAmountDue:        "Amount Due",
    ciCash:             "Cash",
    ciScanPay:          "Scan to pay",
    ciCancelBtn:        "Cancel",
    ciConfirmBtn:       "Confirm",
    ciConfirming:       "Processing...",
    ciSearchPh:         "Search guest / room",
    // ── Today / All view ──
    ciTabToday:         "Arriving today",
    ciTabAll:           "All",
    coTabToday:         "Leaving today",
    coTabAll:           "All",
    // ── Walk-in booking ──
    wiNewBtn:           "New Booking",
    wiTitle:            "Walk-in Booking",
    wiSub:              "For guests booking at the counter",
    wiRoomType:         "Room Type",
    wiRoomTypePh:       "Select room type",
    wiCheckIn:          "Check-in",
    wiCheckOut:         "Check-out",
    wiGuestName:        "Guest Name",
    wiGuestNamePh:      "Full name",
    wiPhone:            "Phone",
    wiPhonePh:          "Contact number (optional)",
    wiNights:           "Nights",
    wiTotal:            "Total",
    wiPayMethod:        "Payment",
    wiCash:             "Cash",
    wiPaidAmount:       "Amount Paid",
    wiPayFull:          "Pay full",
    wiPayNone:          "Not paid",
    wiSubmit:           "Create Booking",
    wiSubmitting:       "Creating...",
    wiSuccess:          "Booking created",
    wiCancelBtn:        "Cancel",
    wiErrRoom:          "Please select a room type",
    wiErrDate:          "Check-out must be after check-in",
    ciLoadingData:      "Loading data...",
    ciNoList:           "No pending check-ins",
    ciErrBadData:       "Invalid data format",
    ciErrConnect:       "Cannot connect to server",
    ciToastCheckinOk:   "Checked in successfully ✓",
    ciToastCheckinFail: "Check-in failed. Please try again",
    ciLoadFail:         "Failed to load",
    ciRoomLabel:        "Room",
    ciCheckinBtn:       "Check In",
    ciAge:              "Age",
    ciReceivedCash:     "Received cash",
    ciReceivedQR:       "Received via QR Code",
    ciUndo:             "Undo",
    ciOk:               "Confirm",

    // ── Check-in for rooms booked together (same groupId) ──
    ciGroupRooms:       (n) => `${n} rooms booked together`,
    ciGroupStep:        (i, n) => `Room ${i} of ${n}`,
    ciGroupHint:        "Fill in every room, then confirm once",
    ciGroupBookedBy:    "Booked by:",
    ciPrevRoom:         "Previous room",
    ciNextRoom:         "Next room",
    ciConfirmAll:       (n) => `Check in all ${n} rooms`,
    ciGroupTotal:       (n) => `Group total (${n} rooms)`,
    ciRoomPrice:        "This room",
    ciCopyPrev:         "Copy details from previous room",
    ciCopiedPrev:       "Details copied ✓",
    ciGroupCheckedIn:   (n) => `${n} rooms checked in ✓`,
    ciGroupPartialFail: (n) => `${n} rooms failed to check in. Please try again`,

    // ── Calendar "check in now" booking — nothing is saved until check-in succeeds ──
    ciDraftBanner:      "This booking is not saved yet — it is created only when check-in is confirmed",
    ciDraftNotSaved:    "Not saved yet",
    ciDraftLeaveConfirm:"Leave without saving? The booking will not be created and all entered details will be lost",
    ciDraftFail:        "Check-in failed. Nothing was saved — your entries are still here, press confirm again",

    // ── CheckIn: staff-entered fields + stay history ──
    ciAdminSection:     "Additional information",
    ciAdminSectionSub:  "Used for receipts and guest analytics reports",
    ciGuestType:        "Guest type",
    ciTypeAuto:         "Suggested from the entered data — select to override",
    ciStayPurpose:      "Purpose of stay",
    ciPurposeSelect:    "-- Select purpose --",
    ciCompanyGroup:     "Company details",
    ciCompanyName:      "Company name",
    ciCompanyAddress:   "Company address",
    ciCompanyBranchNo:  "Branch no.",
    ciCompanyTaxId:     "Tax ID",
    ciCarGroup:         "Vehicle details",
    ciCarNote:          "Not shown on receipts — kept as history and used to analyse where guests come from",
    ciCarBrand:         "Car brand",
    ciCarColor:         "Car colour",
    ciCarPlate:         "Licence plate",
    ciCarProvince:      "Registered province",
    ciProvinceSearchPh: "Type to search province",
    ciLookingUp:        "Searching guest registry...",
    ciReturningGuest:   "Returning guest",
    ciStayCount:        (n) => `${n} previous stay${n === 1 ? "" : "s"}`,
    ciHistTitle:        "Previous stays",
    ciHistSub:          "From the guest registry — showing the 10 most recent",
    ciHistDate:         "Stay dates",
    ciHistRoom:         "Room",
    ciHistType:         "Type",
    ciHistTotal:        "Total",
    ciHistPaid:         "Paid",
    ciHistDue:          "Outstanding",
    ciHistMethod:       "Method",
    ciHistOutstanding:  "Total outstanding",

    // ── CheckOut ──
    coTitle:            "Check Out",
    coBack:             "Back",
    coPayment:          "Payment",
    coRoomPrice:        "Room Price",
    coRoomPaid:         "Paid",
    coExtraItems:       "Additional Items",
    coAddItem:          "Add Item",
    coQty:              "Qty",
    coBalanceDue:       "Balance Due",
    coBalancePaid:      "Balance",
    coPaidFull:         "Fully Paid ✓",
    coPayBtn:           "Pay",
    coNoImage:          "No image",
    coBookingDetail:    "Booking Details",
    coGuests:           "Guest(s)",
    coBookedOn:         "Booked on",
    coCheckIn:          "Check-in",
    coCheckOut:         "Check-out",
    coTotalPrice:       "Total Price",
    coPaidLabel:        "Paid",
    coTotalDue:         "Total Due",
    coConfirm:          "Confirm",
    coConfirming:       "Processing...",
    coPayWarn:          "⚠️ Please make payment before confirming check-out",
    coSearchPh:         "Search guest / room",
    coLoadingData:      "Loading data...",
    coToastLoadFail:    "Failed to load data",
    coToastPayCash:     "Received cash payment",
    coToastPayQR:       "Received payment via QR",
    coToastPaySuffix:   "THB ✓",
    coToastCheckoutOk:  "Checked out successfully ✓ Receipt sent by email",
    coToastCheckoutFail:"Check-out failed",
    coNoList:           "No pending check-outs",
    coCustomer:         "Customer",
    coCheckoutBtn:      "Check Out",
    coLate:             "Late",
    coPayTitle:         "💳 Collect Payment",
    coAmountDue:        "Amount to Pay",
    coCash:             "Cash",
    coScanPay:          "Scan to pay",
    coCancelBtn:        "Cancel",
    coOkBtn:            "Confirm",
    coAddItemTitle:     "Add Item",
    coAddItemSub:       "Enter manually or select from saved items",
    coCustomEntry:      "✏️ Enter Item Manually",
    coItemName:         "Item Name *",
    coUnitPrice:        "Price/Unit (THB) *",
    coServiceItems:     "🏷️ Products / Services",
    coSearchItem:       "Search items...",
    coNoSavedItems:     "No saved items yet",
    coNoSearchItem:     "No items found",
    coAddBtn:           "+ Add",
    coReceivedCash:     "Received cash",
    coReceivedQR:       "Received via QR Code",
    coUndoBtn:          "Undo",
    coAge:              "Age",
    coItemNamePh:       "e.g. Water",

    // ── ReceiptEditor ──
    reConfirmDeleteHotel:    "Delete hotel",
    reConfirmDeleteCustomer: "Delete customer",
    reTitle:            "Edit Receipt",
    reHotelTab:         "Hotel Info",
    reCustomerTab:      "Customer Info",
    reSearchHotel:      "Search hotel data",
    reSearchHotelBtn:   "Search / Manage Hotel",
    reLogo:             "Logo",
    reSignature:        "Signature",
    reHotelName:        "Hotel Name (Thai)",
    reHotelNameEn:      "Hotel Name (English)",
    reTaxId:            "Tax ID",
    reAddress:          "Address",
    reSigner:           "Authorized Signatory",
    reReceiptNo:        "Receipt No.",
    reReceiptDate:      "Receipt Date",
    reIncludeVat:       "Include VAT 7%",
    reNote:             "Note",
    reBankInfo:         "Bank Transfer Info",
    reBankName:         "Account Name",
    reCustomerName:     "Customer Name",
    reCustomerAddr:     "Customer Address",
    reCustomerTax:      "Customer Tax ID",
    reItems:            "Items",
    reAddItem:          "+ Add Item",
    rePrintOriginal:    "Print (Customer Copy)",
    rePrintCopy:        "Print (Company Copy)",
    reHotelList:        "Hotel Data",
    reHotelListSub:     "Select to auto-fill",
    reCreate:           "+ Create",
    reLoading:          "Loading...",
    reNoHotel:          "No hotel data found",
    reEditHotel:        "Edit",
    reDeleteHotel:      "Delete",
    reEditHotelTitle:   "Edit Hotel Info",
    reNewHotelTitle:    "Create New Hotel",
    reSave:             "Save",
    reSaving:           "Saving...",
    reCancelBtn:        "Cancel",
    reChangeLogo:       "Change logo",
    reUploadLogo:       "Upload logo",
    reChangeSign:       "Change signature",
    reUploadSign:       "Upload signature",
    reCustomerList:     "Customers",
    reCustomerListSub:  "Select to auto-fill",
    reEditCustomer:     "Edit Customer",
    reNewCustomer:      "Create New Customer",
    reCustomerNameLbl:  "Customer Name *",
    reCustomerAddrLbl:  "Address",
    reBranchType:       "Office Type",
    reHeadOffice:       "Head Office",
    reBranch:           "Branch",
    reBranchNo:         "Branch No.",
    reBranchNoPh:       "e.g. 00001",
    reSelectBooking:    "Select from bookings",
    reSelectBookingSub: "Select items to add to receipt",
    reManualEntry:      "Enter manually",
    reManualEntrySub:   "Add items not in system",
    reManualForm:       "✏️ Enter Item Manually",
    reItemName:         "Item Name *",
    reItemQty:          "Quantity",
    reItemPrice:        "Price/Unit *",
    reItemDetail:       "Additional detail (optional)",
    reAddBtn:           "+ Add",
    reServiceList:      "🏷️ Products / Services",
    reSearchItem:       "Search items...",
    reNoSavedItems:     "No saved items yet",
    reNoSearchItem:     "No items found",
    reSearchBooking:    "Search room, email, booking ID...",
    reNoMatchBooking:   "No matching bookings",
    reLoadingBooking:   "Loading data...",
    reNights:           "nights",
    reAlreadyAdded:     "Added",
    reBack:             "← Back",
    reToastHotelRequired: "Please enter hotel name",
    reToastHotelCreated:  "New hotel created",
    reToastHotelSaved:    "Saved",
    reToastCustRequired:  "Please enter customer name",
    reToastCustCreated:   "New customer created",
    reToastCustSaved:     "Saved",
    reToastError:         "An error occurred",
    reSearchHotelPh:      "Search hotel name, Tax ID...",
    reHotelNamePh:        "Hotel name in Thai",
    reHotelAddrPh:        "Hotel address",
    reSignerPh:           "Authorized signatory name",
    reBankInfoPh:         "e.g. Payment via Kasikorn Bank account xxx-x-xxxxx-x",
    reBankNamePh:         "e.g. Account name: John Doe",
    reSearchCustomerPh:   "Search name, Tax ID, address...",
    reCustomerNamePh:     "Full name / Company name",
    reCustomerAddrPh:     "Enter customer address",
    reCustomerNamePh2:    "Enter customer name",
    reHotelAddrPh2:       "Your hotel address",
    reTaxIdPh:            "Your hotel tax ID number",
    reNotePh:             "Additional notes",
    reItemNamePh:         "e.g. Water",
    reItemNamePh2:        "Item name",
    reItemDetailPh:       "Details",
    reAddDetailLine:      "+ Add line",
    reRemoveDetailLine:   "Remove this line",
    reNeedItems:          "Please add at least one item before printing",
    reSaveReceiptFail:    "Failed to save receipt — nothing was printed. Please try again",
    reDownloadPdf:        "⬇ Download PDF",

    // ── ReceiptArchive ──
    receiptArchive:  "Receipt Archive",
    raTitle:         "Receipt Archive",
    raSub:           "Search, view, reprint, and download all issued receipts",
    raSearch:        "Search",
    raSearchPh:      "Receipt no. or customer name...",
    raDateFrom:      "From date",
    raDateTo:        "To date",
    raLoad:          "Search",
    raLoading:       "Loading...",
    raLoadFail:      "Failed to load data",
    raNoData:        "No receipts found",
    raTotal:         "Total",
    raUnit:          "receipts",
    raColReceiptNo:  "Receipt No.",
    raColDate:       "Date",
    raColCustomer:   "Customer",
    raColTotal:      "Total (THB)",
    raColReprints:   "Reprints",
    raColStatus:     "Status",
    raStatusAll:     "All statuses",
    raStatusOk:      "Valid",
    raStatusVoid:    "Voided",
    raClose:         "Close",
    raReprint:       "🖨 Reprint",
    raVoid:          "Void receipt",
    raVoidReasonPh:  "Reason for voiding...",
    raVoidConfirm:   "Confirm void",
    raVoidCancel:    "Cancel",
    raVoidedBanner:  "This receipt has been voided",
    raVoidFail:      "Failed to void receipt",
    raPrev:          "← Previous",
    raNext:          "Next →",
    raPage:          "Page",
    raDownloadExcel: "⬇ Download Excel",

    // ── PaymentSettings ──
    psTitle:              "Payment Account Settings",
    psSubtitle:           "Edit PromptPay ID / account name / bank — updates the QR on every page instantly",
    psHotelName:          "Hotel Name *",
    psHotelNamePh:        "Your hotel name",
    psPhone:              "PromptPay Number or National/Tax ID *",
    psPhonePh:            "08X-XXX-XXXX or 13-digit ID",
    psAccountName:        "PromptPay Account Name",
    psAccountNamePh:      "e.g. EURNGKUM Guest House",
    psBankName:           "Bank Name",
    psBankNamePh:         "e.g. Kasikorn Bank",
    psPreview:            "QR Preview",
    psPreviewEmpty:       "Enter a PromptPay number or ID to preview the QR",
    psSave:               "Save",
    psSaving:             "Saving...",
    psLoading:            "Loading...",
    psToastHotelRequired: "Please enter a hotel name",
    psToastPhoneInvalid:  "Must be a 9-10 digit phone number (starting with 0) or a 13-digit National/Tax ID",
    psToastSaved:         "Saved",
    psToastError:         "Something went wrong",

    // ── ServiceItems ──
    siConfirmDelete:    "Delete item",
    siTitle:            "Products / Services",
    siAddBtn:           "+ Add Item",
    siSearch:           "Search items...",
    siLoading:          "Loading...",
    siNoItems:          "No items. Press + to add.",
    siNoSearch:         "No items found",
    siThbUnit:          "THB",
    siEdit:             "Edit",
    siDelete:           "Delete",
    siAddTitle:         "Add New Item",
    siEditTitle:        "Edit Item",
    siNameLabel:        "Item Name *",
    siNamePh:           "e.g. Water, Laundry, Breakfast",
    siPriceLabel:       "Price (THB) *",
    siCancelBtn:        "Cancel",
    siSaveBtn:          "Save",
    siSaving:           "Saving...",
    siToastNameRequired: "Please enter item name",
    siToastPriceInvalid: "Invalid price",
    siToastAdded:        "Item added ✓",
    siToastSaved:        "Saved ✓",
    siToastError:        "An error occurred",
    siToastDeleted:      "Deleted ✓",

    // ── SlipVerification ──
    slipActionFail:     "Action failed. Please try again",
    slipTitle:          "Verify Payment Slips",
    slipSearch:         "Search email...",
    slipRefresh:        "Refresh",
    slipTabAll:         "All",
    slipTabPending:     "Pending",
    slipTabNoSlip:      "Awaiting Slip (Staff)",
    slipTabApproved:    "Approved",
    slipTabRejected:    "Rejected",
    slipColBooker:      "Booker",
    slipColRoom:        "Room",
    slipColPaid:        "Paid",
    slipColTotal:       "Total",
    slipColPayType:     "Payment Type",
    slipColStatus:      "Status",
    slipColDate:        "Date Sent",
    slipColAction:      "Action",
    slipColAmount:      "Amount",
    slipRoomsSummary:   (r, ty) => `${r} room(s) · ${ty} type(s)`,
    slipPaidShort:      (n) => `Paid ${n}`,
    slipUnpaid:         "Unpaid",
    slipRoomList:       "Rooms in this booking",
    slipPrevPage:       "← Prev",
    slipNextPage:       "Next →",
    slipShowAll:        (n) => `Show all (${n})`,
    slipShowPaged:      "Show by page",
    slipPageOf:         (cur, all) => `Page ${cur} of ${all}`,
    slipShowingRange:   (from, to, all) => `Showing ${from}–${to} of ${all}`,
    slipRemaining:      "Remaining",
    payTypeFull:        "Full Payment",
    payTypePartial:     "Deposit",
    payTypeCash:        "Cash on Arrival",
    toastSuccess:       "Success",
    toastError:         "Something went wrong",
    toastWarn:          "Heads up",
    toastInfo:          "Notice",
    slipLoading:        "Loading...",
    slipNoItems:        "No items in this category",
    slipNoAccess:       "No access — admin / staff only",
    slipDetailTitle:    "Slip Detail",
    slipStaffBooking:   "🏷️ Staff Booking — awaiting slip from customer",
    slipCashBooking:    "💵 Cash booking — approve without slip",
    slipEmail:          "Email",
    slipAmount:         "Amount",
    slipStatus:         "Status",
    slipRoom:           "Room",
    slipSentAt:         "Date Sent",
    slipAdminNote:      "Admin note (optional)",
    slipApprove:        "✓ Approve",
    slipReject:         "✗ Reject",
    slipClose:          "Close",
    slipCancelled:      "This booking has been cancelled — cannot approve slip",
    slipPendingCancel:  "Awaiting cancellation confirmation",
    slipUpload:         "📎 Upload Slip from Customer (Staff)",
    slipClickSelect:    "📷 Click to select slip image",
    slipChange:         "Change",
    slipSaveSlip:       "✓ Save Slip",
    slipUploading:      "Uploading...",
    slipProcessing:     "Processing...",
    slipViewSlip:       "View Slip",
    slipAddSlip:        "📎 Add Slip",
    slipViewDetail:     "View Detail",
    slipPendingCancelTag: "Awaiting cancellation",
    slipCancelledTag:   "Cancelled",
    slipToastUploadOk:  "Slip uploaded — status changed to Pending",
    slipToastUploadFail:"Upload failed",
    slipToastLoadFail:  "Failed to load data. Please try again",
    slipToastApproved:  "Approved successfully",
    slipToastRejected:  "Rejected",

    // ── About ──
    aboutTitle:         "About Us",
    aboutConnecting:    "Connecting...",
    aboutConnectOk:     "Connected to Backend! 🚀",
    aboutConnectFail:   "Cannot connect to Backend ❌",

    // ── AdminUsers ──
    auRoleChangeFail:   "Failed to change role",
    auDeleteFail:       "Failed to delete member",
    auActionError:      "An error occurred",
    auSelectRoleFirst:  "Select a new role first",
    auTitle:            "Manage Members",
    auPerson:           "person(s)",
    auRefresh:          "Refresh",
    auSearch:           "Name, email, phone...",
    auAll:              "All",
    auStaff:            "Staff",
    auCustomer:         "Customer",
    auLoadFail:         "Failed to load data",
    auRetry:            "Retry",
    auNoMembers:        "No members found",
    auClearSearch:      "Clear search",
    auJoined:           "Joined",
    auSave:             "Save",
    auDelete:           "Delete",
    auCancel:           "Cancel",
    auConfirmRole:      "Confirm Role Change",
    auConfirmDelete:    "Confirm Delete Member",
    auConfirmRoleDesc:  "Change role of",
    auFrom:             "from",
    auTo:               "to",
    auConfirmQ:         "?",
    auDeleteDesc:       "Remove",
    auDeleteWarn:       "This action cannot be undone",
    auSaving:           "Saving…",
    auDeleting:         "Deleting…",
    auConfirm:          "Confirm",
    auDeleteBtn:        "Delete Member",
    auResultCount:      "Results",
    auItems:            "records",

    // ── AdminCalendar locale ──
    calMonthsTH:     ["January","February","March","April","May","June","July","August","September","October","November","December"],
    calDowTH:        ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
    calUnknownType:  "Unknown",

    // ── AdminDashboard locale ──
    dbMonths: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    dbDays:     ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
    dbDaysFull: ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
    dbOther:  "Other",

    // ── SlipVerification ──
    slipImgAlt: "Slip",
  },
};

export function t(lang, key, ...args) {
  const val = translations[lang]?.[key] ?? translations["th"][key] ?? key;
  return typeof val === "function" ? val(...args) : val;
}

export default translations;
